//====================================================
//  Function: Reposition Detail
// - preusporiadanie prvkov v detaile produktu
// - preusporiadanie hlavičky, popisu, podobných a suvisiacich produktov
//====================================================

var detailHeader;
var detailInfo;
var detailHeaderInner;
var detailImageWrapper;
var detailInfoWrapper;

function componentsRepositionDetail() {
  if ($(".type-detail").length) {
    detailHeader = $(".p-detail-inner");
    detailInfo = $(".p-detail-info");
    detailHeaderInner = $(".p-detail-inner-header");
    detailImageWrapper = $(".product-top > .p-image-wrapper");
    detailInfoWrapper = $(".product-top > .p-info-wrapper");

    // change link for add-to-cart for Mix - sheet
    if (shopName === 'wsk' || shopName === 'whu') {
      disableSheetMixPurchase();
    }
    // add link to twin product on wsk - only pos
    if (shopName === 'pos') {
      externalLinkingToWsk();
    }
    // add link to twin product on whu - only eag (sales stopping on eag)
    if (shopName === 'eag') {
      externalLinkingToWhu();
    }
    // add show video button
    addYoutubeVideoButton();

    // reposition detail info
    repositionDetailHeader();

    // reposition detail description
    repositionDetailDescription();

    // visual changes in short description only for jam, mee and dpc
    if (shopName === 'jam' || shopName === 'mee' || shopName === 'dpc') {
      shortDescriptionSpecificVisualChanges();
    }

    // UPOZORNENIE: VŽDY MÔŽE BYŤ VIDITEĽNÝ LEN JEDEN Z BANNEROV!
    // add banner - eshop of the year only for specific e-shops
    //addBannerEshopOfYear();

    // add banner promotions
    if (shopName === 'wsk' || shopName === 'whu' || shopName === 'wcz' || shopName === 'wro' || shopName === 'whr' || shopName === 'wsi') {
      addBannerPromotions();
    }

    // rename related files to guides
    renameGuides();

    // reposition detail alternative products
    repositionDetailAlternativeProducts();

    // add product variants
    automaticRenderingVariants();

    if(
      $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Nadrozmer")').length
      || $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Túlméretes")').length
      //|| $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Nadrozměr")').length
    ) {
      // add banner with notice about need for assistance in unloading goods
      assistanceInUnloadingGoods();
    }

    if($('#product-detail-form .p-info-wrapper').length) {
      // show expected date delivery if specific status is present
      checkStockStatusToShowExpectedDate();
      // highlight watchdog if product is unavailable
      highlightWatchDog();
      // attach term "delivery" to text about delivery
      prependStockStatusText();

      if($('#product-detail-form .p-info-wrapper .variant-list').length) {
          document.addEventListener('ShoptetVariantAvailable', function () {
              checkStockStatusToShowExpectedDate();
              highlightWatchDog();
          });
      }
    }
    if($('.products.products-block.products-related.products-additional.p-switchable').length){
      if (window.matchMedia('(max-width: ' + bpMedium + 'px)').matches) {
        // modify related products to slider on mobile and tablet devices
        relatedProductsSliderSmallDevices();
      }
    }

    // pexeso badge
    addBadgePexesoDetail();

    // súvisiace kategórie
    repositionCustomCategories();
  }
}

function addYoutubeVideoButton() {
  if($('.p-detail-tabs-wrapper #description iframe[src*="youtube.com"]').length) {
    var buttonText;
    switch(lang) {
      case 'sk':
        buttonText = 'Zobraziť video';
        break;
      case 'hu':
        buttonText = 'Videó megjelenítése';
        break;
      case 'cs':
        buttonText = 'Zobrazit video';
        break;
      case 'ro':
        buttonText = 'Afișați video';
        break;
      case 'bg':
        buttonText = 'Zobraziť video';
        break;
      case 'hr':
        buttonText = 'Prikaži video';
        break;
      case 'sl':
        buttonText = 'Prikazati videoposnetek';
        break;
      case 'uk':
        buttonText = 'Zobraziť video';
        break;
      default:
        return;
    }
    var videoElement = $('.p-detail-tabs-wrapper #description iframe[src*="youtube.com"]:first');
    $(detailInfo).append('<a href="#" class="w-youtube-play-btn">' + buttonText + '</a>')
    $('body').on('click', '.w-youtube-play-btn', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: videoElement.offset().top-60
        }, 500);
    });
  }
}

function repositionDetailHeader() {
  var fullDescriptionTerm;
  switch(lang) {
    case 'sk':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'hu':
      fullDescriptionTerm = 'Teljes leírás';
      break;
    case 'cs':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'ro':
      fullDescriptionTerm = 'Descriere completă';
      break;
    case 'bg':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'hr':
      fullDescriptionTerm = 'Cijeli opis';
      break;
    case 'sl':
      fullDescriptionTerm = 'Celoten opis';
      break;
    case 'uk':
      fullDescriptionTerm = 'Celý popis';
      break;
    default:
      return;
  }
  // reposition product description
  detailInfoWrapper
    .find(".p-short-description, .p-short-description + p")
    .wrapAll('<div class="p-short-description-block"></div>');

  detailInfoWrapper.find(".chevron-down-after").text(fullDescriptionTerm);

  removeDetailInfoLinks();

  addDetailInfoLinks();

  addTopInfoBlock();

  freeDeliveryBlock();

  // setTimeout(() => {
  // 	if ($('.p-short-description-block .chevron-after[href="#description"]').length == 0) {
  // 		$('.p-short-description-block').append(detailInfoWrapper.find('.chevron-after[href="#description"]').closest('p'));
  // 	}
  // }, 1000);
}

function freeDeliveryBlock() {
  var freeShippingTerm;
  switch(lang) {
    case 'sk':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    case 'hu':
      freeShippingTerm = 'Ingyenes Szállítás';
      break;
    case 'cs':
      freeShippingTerm = 'Doprava Zdarma';
      break;
    case 'ro':
      freeShippingTerm = 'Transport Gratuit';
      break;
    case 'bg':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    case 'hr':
      freeShippingTerm = 'Besplatna Dostava';
      break;
    case 'sl':
      freeShippingTerm = 'Brezplačna dostava';
      break;
    case 'uk':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    default:
      return;
  }
  if (detailImageWrapper.find(".flag-freeshipping").length) {
    $(".p-info-wrapper-content .p-final-price-wrapper").append(
      detailImageWrapper.find(".flag-freeshipping")
    );
    $(".p-info-wrapper-content .flag-freeshipping .flag-text").text(freeShippingTerm);
  }
}

function removeDetailInfoLinks() {
  $(".link-icon.share, .link-icon.print ").remove();
}

function addDetailInfoLinks() {
  var socialBlock = $(".link-icons");
  var article;
  var articleLink;
  var questionChatText;
  var watchDogLinkText;
  var transport;
  var faq;
  var packaging;
  var isMattressPage = false;

  switch(lang) {
    case 'sk':
      watchDogLinkText = '<span>Poslať upozornenie,</span><small>keď sa zmení dostupnosť produktu.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    case 'hu':
      watchDogLinkText = '<span>Küldjön figyelmeztetést,</span><small>amennyiben változik a termék elérhetősége.</small>';
      questionChatText = '<span>Kérdésed van?</span><small>Írj nekünk és a specialistáink szívesen segítenek.</small>';
      break;
    case 'cs':
      watchDogLinkText = '<span>Odeslat upozornění,</span><small>když se změní dostupnost produktu.</small>';
      questionChatText = '<span>Máte dotaz?</span><small>Napište nám a naši specialisté vám rádi pomohou.</small>';
      break;
    case 'ro':
      watchDogLinkText = '<span>Trimitere notificare</span><small> când produsul devine disponibil.</small>';
      questionChatText = '<span>Aveți o întrebare?</span><small>Scrieți-ne și specialiștii noștri vă vor ajuta cu plăcere.</small>';
      break;
    case 'bg':
      watchDogLinkText = '<span>Poslať upozornenie </span><small>kada se promijeni dostupnost proizvoda.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    case 'hr':
      watchDogLinkText = '<span>Poslati obavijest</span><small> kada se promijeni dostupnost proizvoda.</small>';
      questionChatText = '<span>Imate pitanje?</span><small>Pišite nam i naši stručnjaci će vam rado pomoći.</small>';
      break;
    case 'sl':
      watchDogLinkText = '<span>Poslati opozorilo, </span><small>ko se razpoložljivost izdelka spremeni.</small>';
      questionChatText = '<span>Imate vprašanje?</span><small> Kontaktirajte nas in naši strokovnjaki vam bodo z veseljem pomagali.</small>';
      break;
    case 'uk':
      watchDogLinkText = '<span>Poslať upozornenie,</span><small>keď sa zmení dostupnosť produktu.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      article = {
        mattress: {
            searchTerm: 'matrace',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Ako vybrať správny matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Ako vybrať rošt na posteľ?'
        }
      };
      transport = {
        link: '/vsetko-o-nakupe/',
        title: 'Všetko o nákupe na Wilsondo.sk',
        text: '(doprava a platba, výnos tovaru, recenzie, reklamácie, pre firmy).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky/',
        title: 'Najčastejšie otázky našich zákazníkov'
      };
      packaging = {
        link: 'https://www.wilsondo.sk/user/documents/upload/Obchodnepodmienky/dolezite-pokyny-udrzba-a-bezne-opotrebenie-tovaru.pdf',
        title: 'Matrac doručujeme zrolovaný.',
        cta: 'Viac sa dočítate tu'
      };
      break;
    case 'whu':
      article = {
        mattress: {
            searchTerm: 'matracok',
            link: '/blog/hasznos-tanacsok-matracvalasztassal-kapcsolatban/',
            title: 'Hogyan válasszunk matracot?'
        },
        childrenMattress: {
            searchTerm: 'Gyerekmatrac',
            link: '/blog/hogyan-valasszam-ki-a-megfelelo-gyerekmatracot/',
            title: 'Hogyan válasszunk gyerekmatracot?'
        },
        bedFrame: {
            searchTerm: 'Ágyrács',
            link: '/blog/milyen-agyracsot-vegyek/',
            title: 'Hogyan válasszam ki a megfelelő ágyrácsot?'
        }
      };
      transport = {
        link: '/vasarlasi-informaciok/',
        title: 'Vásárlással kapcsolatos információk a Wilsondo.hu',
        text: ' -n (szállítás, fizetés, lakásba szállítás, reklamáció, elégedett vásárlók).'
      };
      faq = {
        link: '/gyik-gyakran-ismetlodo-kerdesek/',
        title: 'Gyakran ismételt kérdések'
      };
      packaging = {
        link: 'https://www.wilsondo.hu/user/documents/upload/uzleti-feltetelek/betartando-utasitasok-karbantartas-es-altalanos-elhasznalodas.pdf',
        title: 'A matracot feltekerve szállítjuk.',
        cta: 'Itt olvashat bővebben'
      };
      break;
    case 'wcz':
      article = {
        mattress: {
            searchTerm: 'Matrace',
            link: '/blog/jak-si-vybrat-tu-spravnou-matraci-poradime-vam/',
            title: 'Jak vybrat správnou matraci?'
        },
        childrenMattress: {
            searchTerm: 'Dětské matrac',
            link: '/blog/nevite-vybrat-spravnou-detskou-matraci-pomuzeme-vam/',
            title: 'Jak vybrat správnou dětskou matraci?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/jak-vybrat-rost-na-postel/',
            title: 'Jak vybrat rošt na postel?'
        }
      };
      transport = {
        link: '/vse-o-nakupu/',
        title: 'Vše o nákupu na Wilsondo.cz',
        text: '(doprava a platba, vrácení zboží, recenze, reklamace).'
      };
      faq = {
        link: '/faq-nejcastejsi-dotazy/',
        title: 'Nejčastější dotazy našich zákazníků'
      };
      packaging = {
        link: 'https://www.wilsondo.cz/user/documents/upload/Obchodnipodminky/dulezite-pokyny-udrzba-bezne-opotrebeni-zbozi.pdf',
        title: 'Matraci doručujeme srolovanou.',
        cta: 'Více se dočtete zde'
      };
      break;
    case 'mcz':
      // Morningo.cz — identické s wcz (wilsondo.cz), zamenená je iba doména.
      article = {
        mattress: {
            searchTerm: 'Matrace',
            link: '/blog/jak-si-vybrat-tu-spravnou-matraci-poradime-vam/',
            title: 'Jak vybrat správnou matraci?'
        },
        childrenMattress: {
            searchTerm: 'Dětské matrac',
            link: '/blog/nevite-vybrat-spravnou-detskou-matraci-pomuzeme-vam/',
            title: 'Jak vybrat správnou dětskou matraci?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/jak-vybrat-rost-na-postel/',
            title: 'Jak vybrat rošt na postel?'
        }
      };
      transport = {
        link: '/vse-o-nakupu/',
        title: 'Vše o nákupu na Morningo.cz',
        text: '(doprava a platba, vrácení zboží, recenze, reklamace).'
      };
      faq = {
        link: '/faq-nejcastejsi-dotazy/',
        title: 'Nejčastější dotazy našich zákazníků'
      };
      packaging = {
        link: 'https://www.morningo.cz/user/documents/upload/Obchodnipodminky/dulezite-pokyny-udrzba-bezne-opotrebeni-zbozi.pdf',
        title: 'Matraci doručujeme srolovanou.',
        cta: 'Více se dočtete zde'
      };
      break;
    case 'wro':
      article = {
        mattress: {
            searchTerm: 'Saltele',
            link: '/blog/cum-sa-alegeti-salteaua-potrivita-noi-va-vom-sfatui/',
            title: 'Cum să alegeți salteaua potrivită?'
        },
        bedFrame: {
            searchTerm: 'Paturi',
            link: '/blog/cum-sa-alegeti-o-somiera-de-pat/',
            title: 'Cum să alegeți o somieră de pat?'
        }
      };
      transport = {
        link: '/totul-despre-cumparaturi/',
        title: 'Totul despre cumpărăturile pe Wilsondo.ro',
        text: '(transport și plată, aducerea produselor, recenzii, reclamații).'
      };
      faq = {
        link: '/faq-cele-mai-frecvente-intrebari/',
        title: 'Întrebări frecvente ale clienților noștri'
      };
      packaging = {
        link: 'https://www.wilsondo.ro/user/documents/upload/Conditiicomerciale/instructiuni-importante-mantenanta-si-uzura-necesara-a-bnurilor.pdf',
        title: 'Salteaua este livrată rulată.',
        cta: 'Citiți mai multe aici'
      };
      break;
    case 'wbg':
      article = {
        mattress: {
            searchTerm: '',
            link: '',
            title: ''
        },
        bedFrame: {
            searchTerm: '',
            link: '',
            title: ''
        }
      };
      transport = {
        link: '',
        title: '',
        text: ''
      };
      faq = {
        link: '',
        title: ''
      };
      packaging = {
        link: '',
        title: '',
        cta: ''
      };
      break;
    case 'whr':
      article = {
        mattress: {
            searchTerm: '',
            link: '',
            title: ''
        },
        bedFrame: {
            searchTerm: '',
            link: '',
            title: ''
        }
      };
      transport = {
        link: '/sve-o-kupnji/',
        title: 'Sve o kupovini na Wilsondo.hr',
        text: '(dostava i plaćanje, povrat robe, recenzije, reklamacije).'
      };
      faq = {
        link: '/faq-najcesca-pitanja/',
        title: 'Najčešća pitanja naših kupaca'
      };
      packaging = {
        link: 'https://www.wilsondo.hr/user/documents/upload/vop/vazne_upute_odrzavanje_i_uobicajeno_trosenje_robe_hr.pdf',
        title: 'Madrac dostavljamo zarolan.',
        cta: 'Pročitajte više ovdje'
      };
      break;
    case 'mhr':
      // Morningo.hr — identické s whr (wilsondo.hr), zamenená je iba doména.
      // Blog články nie sú definované (rovnako ako whr) → blok s článkom sa nezobrazí.
      article = {
        mattress: {
            searchTerm: '',
            link: '',
            title: ''
        },
        bedFrame: {
            searchTerm: '',
            link: '',
            title: ''
        }
      };
      transport = {
        link: '/sve-o-kupnji/',
        title: 'Sve o kupovini na Morningo.hr',
        text: '(dostava i plaćanje, povrat robe, recenzije, reklamacije).'
      };
      faq = {
        link: '/faq-najcesca-pitanja/',
        title: 'Najčešća pitanja naših kupaca'
      };
      packaging = {
        link: 'https://www.morningo.hr/user/documents/upload/vop/vazne_upute_odrzavanje_i_uobicajeno_trosenje_robe_hr.pdf',
        title: 'Madrac dostavljamo zarolan.',
        cta: 'Pročitajte više ovdje'
      };
      break;
    case 'wsi':
      article = {
        mattress: {
            searchTerm: '',
            link: '',
            title: ''
        },
        bedFrame: {
            searchTerm: '',
            link: '',
            title: ''
        }
      };
      transport = {
        link: '/vse-o-nakupovanju/',
        title: 'Vse o nakupovanju na Wilsondo.si',
        text: '(dostava in plačilo, pomoč pri natovarjanju/raztovarjanju, mnenja, reklamacije).'
      };
      faq = {
        link: '/pogosta-vprasanja/',
        title: 'Pogosto zastavljena vprašanja naših strank'
      };
      packaging = {
        link: 'https://www.wilsondo.si/user/documents/upload/vop/pomembna_navodila_vzdrzevanje_in_obicajna_obraba_si.pdf',
        title: 'Vzmetnico dostavljamo zvito.',
        cta: 'Več si preberite tukaj'
      };
      break;
    case 'wua':
      article = {
        mattress: {
            searchTerm: '',
            link: '',
            title: ''
        },
        bedFrame: {
            searchTerm: '',
            link: '',
            title: ''
        }
      };
      transport = {
        link: '',
        title: '',
        text: ''
      };
      faq = {
        link: '',
        title: ''
      };
      packaging = {
        link: '',
        title: '',
        cta: ''
      };
      break;
    case 'dpc':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-vybrat-spravny-matrac/',
            title: 'Ako vybrať matrac? Naše tipy'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať najlepší matrac pre dieťa?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/aky-rost-je-vhodny-pod-vas-matrac--a-potrebujete-ho-vobec/',
            title: 'Ako vybrať správny rošt? Naše tipy'
        }
      };
      transport = {
        link: '/doprava-a-platba/',
        title: 'Viac o nákupe na Detskapostel.com',
        text: '(dôležité informácie o cene dopravy, platbe, výnose tovaru).'
      };
      faq = {
        link: '/faq-caste-otazky-zakaznikov/',
        title: 'Odpovede na najčastejši otázky zákazníkov'
      };
      packaging = {
        link: 'https://www.detskapostel.com/user/documents/upload/Obchodnepodmienky/dolezite-pokyny-udrzba-a-bezne-opotrebenie-tovaru.pdf',
        title: 'Matrac doručujeme zrolovaný.',
        cta: 'Viac sa dočítate tu'
      };
      break;
    case 'mee':
      article = {
        mattress: {
            searchTerm: 'matracok',
            link: '/hogyan-valasszunk-matracot//hogyan-valasszunk-matracot/',
            title: 'Hogyan válasszunk matracot?'
        },
        childrenMattress: {
            searchTerm: 'Gyerekmatrac',
            link: '/magazin/hogyan-valasszunk-gyerekmatracot--tippek-a-gyermektippek-a-gyermek-eletkoratol-fugg--en/',
            title: 'Hogyan válasszunk gyerek matracot?'
        },
        bedFrame: {
            searchTerm: 'Ágyrács',
            link: '/magazin/milyen-agyracsot-valasszak-az-agyba/',
            title: 'Hogyan válasszak ágyrácsot az ágyba?'
        }
      };
      transport = {
        link: '/szallitas-fizetes/',
        title: 'Vásárlási információk a Matrac-es-en.hu oldalunkon',
        text: '(szállítási idő, szállítási díj, fizetési feltételek és lakásba szállítás).'
      };
      faq = {
        link: '/gyakran-ismetlodo-kerdesek--gyik/',
        title: 'GYIK - Gyakran ismétlődő kérdések'
      };
      packaging = {
        link: 'https://www.matrac-es-en.hu/user/documents/upload/uzleti-feltetelek/betartando-utasitasok-karbantartas-es-altalanos-elhasznalodas.pdf',
        title: 'A matracot feltekerve szállítjuk.',
        cta: 'Itt olvashat bővebben'
      };
      break;
    case 'jam':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/ako-vybrat-matrac/',
            title: 'Ako vybrať matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/magazin/ako-vybrat-detsky-matrac--tipy-podla-veku-dietata/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/magazin/ako-si-vybrat-rosty-do-postele/',
            title: 'Ako si vybrať rošty do postele?'
        }
      };
      transport = {
        link: '/doprava--platba--vynos/',
        title: 'Informácie o nákupe na Ja-a-matrac.sk',
        text: '(doba dodania, cena dopravy, platby, osobný odber a výnosu tovaru).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky-zakaznikov/',
        title: 'FAQ: Najčastejšie otázky zákazníkov'
      };
      packaging = {
        link: 'https://www.ja-a-matrac.sk/user/documents/upload/Obchodnepodmienky/dolezite-pokyny-udrzba-a-bezne-opotrebenie-tovaru.pdf',
        title: 'Matrac doručujeme zrolovaný.',
        cta: 'Viac sa dočítate tu'
      };
      break;
    case 'eag':
      // Sales stopping on eag — redirect the info links to their wilsondo.hu
      // twins (same paths as the whu case, prefixed with the full domain).
      article = {
        mattress: {
          searchTerm: 'matracok',
          link: 'https://www.wilsondo.hu/blog/hasznos-tanacsok-matracvalasztassal-kapcsolatban/?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking',
          title: 'Milyen matracot vegyek?'
        },
        childrenMattress: {
          searchTerm: 'Gyerekmatrac',
          link: 'https://www.wilsondo.hu/blog/hogyan-valasszam-ki-a-megfelelo-gyerekmatracot/?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking',
          title: 'Milyen gyerekmatracot vegyek?'
        },
        bedFrame: {
          searchTerm: 'Ágyrács',
          link: 'https://www.wilsondo.hu/blog/milyen-agyracsot-vegyek/?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking',
          title: 'Milyen ágyrács a megfelelő a matracához? Mi segítünk választani!'
        }
      };
      transport = {
        link: 'https://www.wilsondo.hu/vasarlasi-informaciok/?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking',
        title: 'Vásárlással kapcsolatos információk a Emeletes-agyak.hu',
        text: 'Szállítás, Fizetés, Lakásba szállítás'
      };
      faq = {
        link: 'https://www.wilsondo.hu/gyik-gyakran-ismetlodo-kerdesek/?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking',
        title: 'Gyakran ismétlődő kérdések'
      };
      packaging = {
        link: 'https://www.wilsondo.hu/user/documents/upload/uzleti-feltetelek/betartando-utasitasok-karbantartas-es-altalanos-elhasznalodas.pdf',
        title: 'A matracot feltekerve szállítjuk.',
        cta: 'Itt olvashat bővebben'
      };
    break;
    case 'pos':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-si-vybrat-spravny-matrac/',
            title: 'Poradíme vám, ako vybať matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/ako-vybrat-detsky-matrac--poradime-vam/',
            title: 'Poradíme vám, ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'postele',
            link: '/blog/typy-posteli-vhodna-postel-do-kazdej-izby/',
            title: 'Ako si vybrať vhodnú posteľ?'
        }
      };
      transport = {
        link: 'https://www.wilsondo.sk/vsetko-o-nakupe/?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking',
        title: 'Viac informácií o nákupe',
        text: '(doručenie, platba, doba dodania, výnos...)'
      };
      faq = {
        link: 'https://www.wilsondo.sk/faq-najcastejsie-otazky/?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking',
        title: 'Časté otázky našich zákazníkov | FAQ'
      };
    break;
    default:
    return;
  }

  // Add dynamic blog article link
  if ($(detailInfoWrapper).length) {
    var crumbsText = $('[itemprop="itemListElement"] [itemprop="name"]')
      .map(function () {
        return $(this).text().toLowerCase();
      })
      .get()
      .join(' | ');

    var mattressTerm         = ((article && article.mattress && article.mattress.searchTerm) || '').toLowerCase();
    var childrenMattressTerm = ((article && article.childrenMattress && article.childrenMattress.searchTerm) || '').toLowerCase();
    var bedFrameTerm         = ((article && article.bedFrame && article.bedFrame.searchTerm) || '').toLowerCase();

    var isChildrenMattressPage = childrenMattressTerm && crumbsText.includes(childrenMattressTerm);
    var isBedFramePage         = bedFrameTerm && crumbsText.includes(bedFrameTerm);
    isMattressPage             = mattressTerm && crumbsText.includes(mattressTerm) && !isChildrenMattressPage;

    var isAnyMattressPage      = isMattressPage || isChildrenMattressPage;

    if (isChildrenMattressPage) {
      articleLink = '<a href="' + article.childrenMattress.link + '" target="_blank" class="link-icon article-help-info" title="' + article.childrenMattress.title + '"><span>' + article.childrenMattress.title + '</span></a>';
    } else if (isBedFramePage) {
      articleLink = '<a href="' + article.bedFrame.link + '" target="_blank" class="link-icon article-help-info" title="' + article.bedFrame.title + '"><span>' + article.bedFrame.title + '</span></a>';
    } else if (isMattressPage) {
      articleLink = '<a href="' + article.mattress.link + '" target="_blank" class="link-icon article-help-info" title="' + article.mattress.title + '"><span>' + article.mattress.title + '</span></a>';
    }
  }
  // Link article - The article has to help customer with purchase
  if (articleLink) socialBlock.prepend($(articleLink));

  // Link - PDF
  if (isAnyMattressPage && packaging) {
    var packagingLink = '<a href="' + packaging.link + '" target="_blank" class="link-icon packaging" title="' + packaging.title + '" rel="nofollow"><span>' + packaging.title + '</span><small>' + packaging.cta + '</small></a>';
    socialBlock.prepend($(packagingLink));
  }

  // Link chat - Do you have question? - Customer can write to our support
  $(".link-icon.chat").html(questionChatText);

  // Link watchdog - Option to set alert that product is available
  $(".link-icon.watchdog").html(watchDogLinkText);

  // Link transport - All about shopping
  var transportLink = '<a href="'+ transport.link +'" class="link-icon transport" title="' + transport.title + '" rel="nofollow"><span>' + transport.title + '</span><small>' + transport.text + '</small></a>';
  socialBlock.append($(transportLink));

  // Link faq
  var faqLink = '<a href="' + faq.link + '" class="link-icon faq" title="' + faq.title + '" rel="nofollow"><span>' + faq.title + '.</span></a>';
  socialBlock.append($(faqLink));
}

function addTopInfoBlock() {
  detailInfoWrapper
    .find("> *:not(.p-short-description-block):not(.social-buttons-wrapper)")
    .wrapAll('<div class="p-info-wrapper-content"></div>');

  detailImageWrapper.prepend(detailInfo);
  detailImageWrapper.prepend(detailHeaderInner);

  var mattressBasicParameters;
  switch(lang) {
    case 'sk':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    case 'hu':
      mattressBasicParameters = ['Keménység:', 'Terhelhetőség:', 'Magasság:'];
      break;
    case 'cs':
      mattressBasicParameters = ['Tvrdost:', 'Nosnost:', 'Výška:'];
      break;
    //TODO WRO: určiť podľa toho ako urobíme preklad! musí to byť jednotné všade tie isté 3 slová + dvojbodka
    case 'ro':
      mattressBasicParameters = ['Duritate:', 'Capacitate:', 'Înălțime:'];
      break;
    case 'bg':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    case 'hr':
      mattressBasicParameters = ['Tvrdoća:', 'Nosivost:', 'Visina:'];
      break;
    case 'sl':
      mattressBasicParameters = ['Trdota:', 'Nosilnost:', 'Višina:'];
      break;
    case 'uk':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    default:
      return;
  }
  //add class 'mattress-basic-parameters' if does not exists
  $.each(mattressBasicParameters, function(index, mattressBasicParameter) {
    var mattressParameterParagraph = $('.p-info-wrapper .p-short-description p:has(strong:contains("' + mattressBasicParameter + '"))');

    //check if p already has class 'mattress-basic-parameters', apply only if it does not
    if (mattressParameterParagraph.length > 0 && !mattressParameterParagraph.hasClass('mattress-basic-parameters')) {
      mattressParameterParagraph.addClass('mattress-basic-parameters');
    }
  });

  // basic parameters for mattresses
  if ($(".mattress-basic-parameters").length) {
    $(".p-info-wrapper .mattress-basic-parameters").wrapAll(
      '<div class="mattress-basic-parameters-block"></div>'
    );
    $(".mattress-basic-parameters-block").insertAfter(
      ".p-info-wrapper-content .add-to-cart"
    );
  }

  // basic parameters for wardrobes
  if ($(".wardrobe-basic-parameters").length) {
    $(".p-info-wrapper .wardrobe-basic-parameters").wrapAll(
      '<div class="wardrobe-basic-parameters-block"></div>'
    );
    $(".wardrobe-basic-parameters-block").insertAfter(
      ".p-info-wrapper-content .add-to-cart"
    );
  }
}

function repositionDetailDescription() {
  var ratingTerm;
  switch(lang) {
    case 'sk':
      ratingTerm = 'Hodnotenia';
      break;
    case 'hu':
      ratingTerm = 'Értékelések';
      break;
    case 'cs':
      ratingTerm = 'Hodnocení';
      break;
    case 'ro':
      ratingTerm = 'Evaluări';
      break;
    case 'bg':
      ratingTerm = 'Hodnotenia';
      break;
    case 'hr':
      ratingTerm = 'Ocjene';
      break;
    case 'sl':
      ratingTerm = 'Mnenja';
      break;
    case 'uk':
      ratingTerm = 'Hodnotenia';
      break;
    default:
      return;
  }
  if ($('#ratingTab .rate-average').length) {
    $('#ratingTab').prepend('<h3>'+ ratingTerm + '</h3>');
  }
}

function renameGuides() {
  if ($('.p-detail-tabs-wrapper').length) {
    var relatedFiles;
    var guides;
    switch(lang) {
      case 'sk':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      case 'hu':
        relatedFiles = 'Kapcsolódó fájlok';
        guides = 'Szerelési útmutató';
        break;
      case 'cs':
        relatedFiles = 'Související soubory';
        guides = 'Návody';
        break;
      case 'ro':
        relatedFiles = 'Fişiere asociate';
        guides = 'Instrucțiuni';
        break;
      case 'bg':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      case 'hr':
        relatedFiles = 'Povezane datoteke';
        guides = 'Upute';
        break;
      case 'sl':
        relatedFiles = 'Povezane datoteke';
        guides = 'Navodila za uporabo';
        break;
      case 'uk':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      default:
        return;
    }

    $('.p-detail-tabs-wrapper .shp-tab-link:contains("' + relatedFiles + '")').text(guides);
  }
  $('.shp-tabs-holder').show();
}

function repositionDetailAlternativeProducts() {
  if ($(".tab-pane#productsAlternative").length) {
    var productsAlternative = $(".tab-pane#productsAlternative");
    var alternativeProductTerm;
    switch(lang) {
      case 'sk':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'hu':
        alternativeProductTerm = 'Hasonló termékek';
        break;
      case 'cs':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'ro':
        alternativeProductTerm = 'Alternativ';
        break;
      case 'bg':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'hr':
        alternativeProductTerm = 'Slični proizvodi';
        break;
      case 'sl':
        alternativeProductTerm = 'Podobni izdelki';
        break;
      case 'uk':
        alternativeProductTerm = 'Podobné produkty';
        break;
      default:
        return;
    }
    productsAlternative.wrapInner(
      '<div class="products-alternative-block"></div>'
    );

    $(".products-alternative-block").insertAfter(".p-detail-tabs-wrapper");
    $('.shp-tab-link[href="#productsAlternative"]')
      .closest(".shp-tab")
      .remove();
    $(".products-alternative-block").prepend(
      '<h2 class="products-alternative-header">' + alternativeProductTerm + '</h2>'
    );
  }
}

function automaticRenderingVariants() {
  var firstDetailElement = $('.products-alternative-block').length;
  var secondDetailElement = $('.p-info-wrapper .availability-value').length;

  if (firstDetailElement && secondDetailElement) {
    var automaticVariantTerm;
    var dimensionTerm;
    var dimensionWardrobeTerm;
    var breadcrumbsCategoryTerm;
    var colorVariantTerm;
    var heightVariantTerm; 

    switch (lang) {
      case 'sk':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        heightVariantTerm = 'Výška';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'hu':
        automaticVariantTerm = 'Kivitel';
        dimensionTerm = 'Méret';
        dimensionWardrobeTerm = 'Szélesség cm-ben';
        colorVariantTerm = 'Szín';
        heightVariantTerm = 'Vastagság';
        breadcrumbsCategoryTerm = 'MATRACOK';
        break;
      case 'cs':
        automaticVariantTerm = 'Provedení';
        dimensionTerm = 'Rozměr';
        dimensionWardrobeTerm = 'Šířka v cm';
        colorVariantTerm = 'Barva';
        heightVariantTerm = 'Výška';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'ro':
        automaticVariantTerm = 'Execuție';
        dimensionTerm = 'Dimensiuni';
        dimensionWardrobeTerm = 'Lățime în cm';
        colorVariantTerm = 'Culoare';
        heightVariantTerm = 'Înălțime';
        breadcrumbsCategoryTerm = 'SALTELE';
        break;
      case 'bg':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        heightVariantTerm = 'Височина';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'hr':
        automaticVariantTerm = 'Izvedba';
        dimensionTerm = 'Dimenzija';
        dimensionWardrobeTerm = 'Širina u cm';
        colorVariantTerm = 'Boja';
        heightVariantTerm = 'Visina';
        breadcrumbsCategoryTerm = 'MADRAC';
        break;
      case 'sl':
        automaticVariantTerm = 'Izvedba';
        dimensionTerm = 'Dimenzija';
        dimensionWardrobeTerm = 'Širina v cm';
        colorVariantTerm = 'Barva';
        heightVariantTerm = 'Višina';
        breadcrumbsCategoryTerm = 'VZMETNICE';
        break;
      case 'uk':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        heightVariantTerm = 'Висота';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      default:
        return;
    }

    $('.products-alternative-block a.image').clone().removeClass('image').addClass('automatic-variant-img').insertAfter('.p-info-wrapper .availability-value').wrapAll("<div class='wrapper-automatic-variants'></div>");
    $('.p-info-wrapper .wrapper-automatic-variants').hide();
    $('.automatic-variant-img img').each(function (index) {
      $(this).attr('src', $(this).attr('data-src'));
    });
    $('.p-main-image img').first().clone().prependTo('.wrapper-automatic-variants').wrap('<a href="#" class="automatic-variant-img first-automatic-variant-img"></a>');
    $('.wrapper-automatic-variants').prepend('<p class="automatic-variants-title">' + automaticVariantTerm + '</p>');
    $('a.automatic-variant-img').wrapAll('<div class="scroll-automatic-variants"></div>');
    $('.p-info-wrapper .wrapper-automatic-variants').show();

    // Check for the word "MATRACE" in #navigation-1 span
    if ($('#navigation-1 span').text().toUpperCase().includes(breadcrumbsCategoryTerm) || $('#navigation-2 span').text().toUpperCase().includes(breadcrumbsCategoryTerm)) {
      // Hide images in .automatic-variant-img img and .first-automatic-variant-img img
      $('.automatic-variant-img img, .first-automatic-variant-img img').hide();

      // Replace images with the dimension from the href attribute for each .automatic-variant-img
      $('.automatic-variant-img').each(function () {
        var href = $(this).attr('href');
        var dimensionMatch = href.match(/(\d+x\d+)/);

        if (dimensionMatch) {
          var dimension = dimensionMatch[0];
          $('.automatic-variants-title').text(dimensionTerm);
          $(this).append('<span class="dimension-text">' + dimension + '</span>');
        }
      });

      // Get the dimension from the current URL and insert it for .first-automatic-variant-img
      var currentUrl = window.location.href;
      var currentDimensionMatch = currentUrl.match(/(\d+x\d+)/);

      if (currentDimensionMatch) {
        var currentDimension = currentDimensionMatch[0];
        $('.automatic-variants-title').text(dimensionTerm);
        $('.first-automatic-variant-img').append('<span class="dimension-text-first">' + currentDimension + '</span>');
      }
    }

    // Creating automatic rendering variants if wardrobe-basic-parameters exists
    if ($('#product-detail-form .wardrobe-basic-parameters').length > 0) {
      // Hide images in .automatic-variant-img img and .first-automatic-variant-img img
      $('.automatic-variant-img img, .first-automatic-variant-img img').hide();

      // Replace images with the dimension from the href attribute for each .automatic-variant-img
      $('.automatic-variant-img').each(function () {
        var href = $(this).attr('href');
        var dimensionMatch = href.match(/(\d+)x/);

        if (dimensionMatch) {
          var dimension = dimensionMatch[1];
          $('.automatic-variants-title').text(dimensionWardrobeTerm);
          $(this).append('<span class="dimension-text">' + dimension + '</span>');
        }
      });

      // Get the dimension from the current URL and insert it for .first-automatic-variant-img
      var currentUrl = window.location.href;
      var currentDimensionMatch = currentUrl.match(/(\d+)x/);

      if (currentDimensionMatch) {
        var currentDimension = currentDimensionMatch[1];
        $('.automatic-variants-title').text(dimensionWardrobeTerm);
        $('.first-automatic-variant-img').append('<span class="dimension-text-first">' + currentDimension + '</span>');
      }
    }

    // Now we check if the dimension-text in automatic-variant-img is the same as in first-automatic-variant-img
    $('.automatic-variant-img').each(function () {
      var dimensionText = $(this).find('.dimension-text').text();
      var firstDimensionText = $('.first-automatic-variant-img .dimension-text-first').text();

      // If the dimension-text is the same, show the image instead of the dimension
      if (dimensionText === firstDimensionText) {
        $(this).find('img').show();  // Show the image
        $(this).find('.dimension-text').hide();  // Hide the dimension text
        $(this).addClass('with-image').removeClass('without-image');
      } else {
        $(this).find('img').hide();  // Hide the image
        $(this).find('.dimension-text').show();  // Show the dimension text
        $(this).addClass('without-image').removeClass('with-image');
      }
    });

    // Check if there are elements with images and also elements without images if they are we need 2 sliders
    var withImageElements = $('.automatic-variant-img.with-image');
    var withoutImageElements = $('.automatic-variant-img.without-image');
    var detailProductImage = $('.p-main-image img').first();

    if (withImageElements.length > 0 && withoutImageElements.length > 0) {
      // If there is at least one element with the class 'with-image'
      if (withImageElements.length > 0) {
        // Create a new wrapper with the class '.automatic-variants-color-wrap'
        var colorVariantsWrapper = $('<div class="automatic-variants-color-wrap"></div>');

        // Wrap the new wrapper in '.scroll-automatic-variants' to style the scroller
        var scrollWrapper = $('<div class="scroll-automatic-variants"></div>');
        scrollWrapper.append(colorVariantsWrapper);

        // For each found element with the class '.with-image', append it to the new wrapper
        withImageElements.each(function () {
          colorVariantsWrapper.append($(this));
        });

        // Clone main image and prepend it to the new wrapper
        var detailProductImage = detailProductImage.clone();
        detailProductImage.wrap('<a href="#" class="automatic-variant-img first-automatic-variant-img"></a>');
        colorVariantsWrapper.prepend(detailProductImage.parent());

        // Attach new scroller to main wrapper
        $('.wrapper-automatic-variants').prepend(scrollWrapper);

        // Mattresses: render variant slider as height (WxLxH -> 3rd value)
        // Detect mattress category via breadcrumbs
        var isMattressCategory = $('#navigation-1 span').text().toUpperCase().includes(breadcrumbsCategoryTerm) || $('#navigation-2 span').text().toUpperCase().includes(breadcrumbsCategoryTerm);
        // Read current product title (H1)
        var mainTitle = $('.p-detail-inner-header h1').text() || '';
        // Regex for WxLxH (supports both "x" and "×")
        var heightRegex = /(\d+)[x×](\d+)[x×](\d+)/;
        // Only enable "Height" mode if current product contains WxLxH on URL or H1
        var mainHeightMatch = (currentUrl + ' ' + mainTitle).match(heightRegex);
        // Require at least one alternative product to contain WxLxH
        var alternativeHeightMatch = false;

        if (isMattressCategory && mainHeightMatch) {
          // Scan alternatives inside this slider (skip the first/current item)
          colorVariantsWrapper.find('a.automatic-variant-img').each(function () {
            if ($(this).hasClass('first-automatic-variant-img')) {
              return;
            }

            var href = $(this).attr('href') || '';
            var title = '';
            var heightMatch = href.match(heightRegex);
            // Pull title from the alternative products list by matching href
            if (!heightMatch) {
              title = $('.products-alternative-block .name[href="' + href + '"]').text() || '';
              heightMatch = title.match(heightRegex);
            }
            // If any alternative has WxLxH, allow the Height slider
            if (heightMatch) {
              alternativeHeightMatch = true;
              return false;
            }
          });
        }

        // Title switches to "Height" only when BOTH gates are satisfied, otherwise stays "Color"
        colorVariantsWrapper.prepend('<p class="automatic-variants-title">' + ((isMattressCategory && mainHeightMatch && alternativeHeightMatch) ? heightVariantTerm : colorVariantTerm) + '</p>');

        if (isMattressCategory && mainHeightMatch && alternativeHeightMatch) {
          // In Height mode, hide images and render height text instead
          colorVariantsWrapper.find('a.automatic-variant-img img').hide();
          colorVariantsWrapper.find('a.automatic-variant-img').each(function () {
            var href = $(this).attr('href') || '';
            var title = '';
            var heightMatch = href.match(heightRegex);

            // For the current product (href "#" or empty), take WxLxH from H1/URL
            if (!heightMatch && (href === '#' || href === '')) {
              title = $('.p-detail-inner-header h1').text() || '';
              heightMatch = (title + ' ' + currentUrl).match(heightRegex);
            }

            // For alternatives, take WxLxH from the alternative product title (matched by href)
            if (!heightMatch) {
              title = $('.products-alternative-block .name[href="' + href + '"]').text() || '';
              heightMatch = title.match(heightRegex);
            }

            if (heightMatch) {
              // Third value is the height
              var height = heightMatch[3];
              // Prevent duplicates: remove existing dimension labels before adding height
              $(this).find('.dimension-text, .dimension-text-first').remove();
              // Keep the same visual styling as the existing dimension labels
              if ($(this).hasClass('first-automatic-variant-img')) {
                $(this).append('<span class="dimension-text-first">' + height + '</span>');
              } else {
                $(this).append('<span class="dimension-text">' + height + '</span>');
              }
            }
          });
        }
      }
    }
  }
}

function checkStockStatusToShowExpectedDate() {
  var validStockStatus;
  var deliveryTimeLabelTerm = $('.delivery-time-label').text();
  var currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label:visible').text().trim();
  switch (lang) {
    case 'sk':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
        'Skladom | Garancia doručenia do Vianoc',
        'Skladom - doručíme do 48 hodín | Garancia doručenia do Vianoc',
        'Skladom - odošleme do 24 hodín | Doručenie do Vianoc negarantujeme',
        'Skladom - odošleme do 24 hodín | Doručíme až po Novom roku',
        'Skladom | Doručenie do Vianoc negarantujeme',
        'Skladom | Doručíme až po Novom roku',
      ];
      break;
    case 'hu':
      validStockStatus = [
        'Raktáron',
        'Raktáron | 48 órán belül kézbesítjük',
        'Raktáron | 24 órán belül feladjuk',
        'Raktáron | Garantáltan kiszállítjuk karácsonyig',
        'Raktáron - 24 órán belül feladjuk | Garantáltan kiszállítjuk karácsonyig',
        'Raktáron - 24 órán belül feladjuk | Nem garantáljuk a kiszállítást karácsonyig',
        'Raktáron - 24 órán belül feladjuk | Kézbesítés már csak az új évben',
        'Raktáron | Nem garantáljuk a kiszállítást karácsonyig',
        'Raktáron | Kézbesítés már csak az új évben',
      ];
      deliveryTimeLabelTerm = 'Legkésőbbi kézbesítési dátum:';
      break;
    case 'cs':
      validStockStatus = [
        'Skladem',
        'Skladem | Doručení do 48h',
        'Skladem | Odesíláme do 24h',
        'Skladem | Zaručené dodání do Vánoc',
        'Skladem - odesíláme do 24h | Zaručené dodání do Vánoc',
        'Skladem - odesíláme do 24h | Dodání do Vánoc není garantováno',
        'Skladem - odesíláme do 24h | Dodáme po Novém roce',
        'Skladem | Dodání do Vánoc není garantováno',
        'Skladem | Dodáme po Novém roce',
      ];
      break;
    case 'ro':
      validStockStatus = [
        'În stoc',
        'În stoc | Livrarăm în 48 de ore',
        'În stoc | Expediem în 24 de ore',
        'În stoc | Livrare garantată până la Crăciun',
        'În stoc - expediem în 24 de ore | Livrare garantată până la Crăciun',
        'În stoc - expediem în 24 de ore | Livrarea până de Crăciun nu este garantată',
        'În stoc - expediem în 24 de ore | Vom livra după Anul Nou',
        'În stoc | Livrarea până de Crăciun nu este garantată',
        'În stoc | Vom livra după Anul Nou',
      ];
      break;
    case 'bg':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
      ];
      break;
    case 'hr':
      validStockStatus = [
        'Na stanju',
        'Na stanju | Šaljemo u roku od 24 sata',
        'Na stanju | Jamstvo dostave do Božića',
        'Na stanju - dostavit ćemo u roku od 48 sati | Jamstvo dostave do Božića',
        'Na stanju - poslat ćemo u roku od 24 sata | Dostavu do Božića ne garantiramo',
        'Na stanju - poslat ćemo u roku od 24 sata | Dostavit ćemo nakon Nove godine',
        'Na stanju | Dostavu do Božića ne garantiramo',
        'Na stanju | Dostavit ćemo nakon Nove godine',
      ];
      break;
    case 'sl':
      validStockStatus = [
        'Na zalogi',
        'Na zalogi | Pošljemo v 24 urah',
        'Na zalogi | Zagotovljena dostava do božiča',
        'Na zalogi - dostavimo v 48 urah | Zagotovljena dostava do božiča',
        'Na zalogi - odposlano v 24 urah | Božična dostava ni zagotovljena',
        'Na zalogi - odposlano v 24 urah | Paket vam dostavimo po novem letu',
        'Na zalogi | Dostava do božiča ni zagotovljena',
        'Na zalogi | Paket vam dostavimo po novem letu',
      ];
      break;
    case 'uk':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
      ];
      break;
    default:
      return;
  }

  if(!currentStatus) {
    currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label').text().trim();
  }
  if(validStockStatus.indexOf(currentStatus) > -1) {
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time-label').addClass('active').text(deliveryTimeLabelTerm);
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time').addClass('active');
  } else {
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time-label').removeClass('active');
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time').removeClass('active');
  }
}

function assistanceInUnloadingGoods() {
  var hasBigproduct = false;
  var link = '/asistencia-pri-doruceni/';
  var altText = 'Potrebná asistencia pri vyložení produktu';
  var image;
  var version = 5;

  switch(lang) {
    case 'sk':
      link = '/asistencia-pri-doruceni/';
      altText = 'Potrebná asistencia pri vyložení produktu';
      break;
    case 'hu':
      link = '/kozremukodo-segitseg-kezbesiteskor/';
      altText = 'Szükséges asszisztencia a termék kipakolásánál';
      break;
    // TODO: skryté pretože výnos vieme poskytnúť len v prípade našej dopravy nie externých kuriérov
    //case 'cs':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    //  case 'ro':
    //  link = '/asistencia-pri-doruceni/';
    //  altText = 'Este necesară asistență la descărcarea produsului';
    //  break;
    //case 'bg':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    //case 'hr':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potrebna asistencija pri istovaru proizvoda';
    //  break;
    //case 'sl':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Pri raztovarjanju izdelka je potrebna pomoč';
    //  break;
    //case 'uk':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/nadrozmer_wsk.svg?v'+version;
      break;
    case 'whu':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/nadrozmer_whu.svg?v'+version;
      break;
    //case 'wcz':
    //  version = 1;
    //  image = 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/nadrozmer_2_cz.svg?v'+version;
    //  break;
    case 'dpc':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/dpc/nadrozmer_dpc.svg?v'+version;
      break;
    case 'mee':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/mee/nadrozmer_mee.svg?v'+version;
      break;
    case 'jam':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/jam/nadrozmer_jam.svg?v'+version;
      break;
    case 'eag':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/eag/nadrozmer_eag.svg?v'+version;
      break;
    case 'pos':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/pos/nadrozmer_pos.svg?v'+version;
      break;
    default:
      return;
  }
  var html = '<div class="notice-w-2"><a href="'+link+'"><img src="'+image+'" alt="'+altText+'" /></a></div>';
  $(html).insertBefore('.p-short-description-block');
  hasBigproduct = true;
}

function highlightWatchDog() {
  var textStatus;
  switch(lang) {
    case 'sk':
      textStatus = 'Nedostupné';
      break;
    case 'hu':
      textStatus = 'Nem elérhető';
      break;
    case 'cs':
      textStatus = 'Momentálně nedostupné';
      break;
    case 'ro':
      textStatus = 'Nu este disponibil';
      break;
    case 'bg':
      textStatus = 'Nedostupné';
      break;
    case 'hr':
      textStatus = 'Nedostupno';
      break;
    case 'sl':
      textStatus = 'Ni na voljo';
      break;
    case 'uk':
      textStatus = 'Nedostupné';
      break;
    default:
      return;
  }
  var currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label:visible').text().trim();
  if(!currentStatus) {
      currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label').text().trim();
  }
  if(currentStatus == textStatus) {
      $('#product-detail-form .p-info-wrapper .link-icon.watchdog').addClass('highlighted');
  } else {
      $('#product-detail-form .p-info-wrapper .link-icon.watchdog').removeClass('highlighted');
  }
}

function relatedProductsSliderSmallDevices() {
  $('.products.products-block.products-related.products-additional.p-switchable')
    .addClass('related-products-small-devices-wrapper')
    .find('.product')
    .removeClass('col-sm-6 col-md-12 col-lg-6 active inactive related-sm-screen-hide related-sm-screen-show')
    .addClass('related-product-small-devices');
}

function prependStockStatusText() {
  var inStockText;
  var emptyVariantText;
  var prependText;

  switch(lang) {
    case 'sk':
      inStockText = 'skladom';
      emptyVariantText = 'zvoľte';
      prependText = 'Dodanie: ';
      break;
    case 'hu':
      inStockText = 'raktáron';
      emptyVariantText = 'kérjük';
      prependText = 'Szállítás: ';
      break;
    case 'cs':
      inStockText = 'skladem';
      emptyVariantText = 'zvolte';
      prependText = 'Dodání: ';
      break;
    case 'ro':
      inStockText = 'în stoc';
      emptyVariantText = 'alegeți';
      prependText = 'Livrare: ';
      break;
    case 'bg':
      inStockText = 'skladom';
      emptyVariantText = 'odaberite';
      prependText = 'Dodanie: ';
      break;
    case 'hr':
      inStockText = 'na stanju';
      emptyVariantText = 'odaberite';
      prependText = 'Dostava: ';
      break;
    case 'sl':
      inStockText = 'na zalogi';
      emptyVariantText = 'izberite';
      prependText = 'Dostava: ';
      break;
    case 'uk':
      inStockText = 'skladom';
      emptyVariantText = 'zvoľte';
      prependText = 'Dodanie: ';
      break;
    default:
      return;
  }

  $('#product-detail-form .p-info-wrapper .availability-value .availability-label').each(function( index ) {
      if (
        $(this).text().toLowerCase().indexOf(inStockText) === -1 &&
        $(this).text().toLowerCase().indexOf(prependText.toLowerCase()) === -1 &&
        $(this).text().toLowerCase().indexOf(emptyVariantText.toLowerCase()) === -1
      ) {
          $(this).text(prependText + $(this).text());
      }
  });
}

function addBannerEshopOfYear() {
  switch(shopName) {
    case 'wsk':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/wsk-e-shop-of-the-year-award.png?v1";
      break;
    case 'wcz':
      var eshopOfYearLink = "/recenze/wilsondo-recenze-a-zkusenosti-zakazniku/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/wcz-e-shop-of-the-year-award.png?v1";
      break;
    case 'wro':
      var eshopOfYearLink = "/de-ce-sa-cumparati-de-la-noi/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/wro-e-shop-of-the-year-award.png?v1";
      break;
    case 'wbg':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/eshop_of_year_wsk.svg?v1";
      break;
    case 'whr':
      var eshopOfYearLink = "/recenzije-wilsondo/recenzije/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whr/whr-e-shop-of-the-year-award.png?v1";
      break;
    case 'wsi':
      var eshopOfYearLink = "/wilsondo-mnenja/pregledi/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsi/wsi-e-shop-of-the-year-award.png?v1";
      break;
    case 'wua':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/eshop_of_year_wsk.svg?v1";
      break;
    default:
      return;
  }
  if ($(".social-buttons-wrapper").length) {
    var bannerEshopOfYear = '<div class="eshop-of-year"><a href="' + eshopOfYearLink + '"><img src="' + eshopOfYearImageUrl + '" alt="Shop roku 2023 - Finalista | Wilsondo.sk"></a></div>';
    $('.social-buttons-wrapper').before(bannerEshopOfYear);
  }
}

function addBannerPromotions() {
  var promotionUrl;
  var promotionImageUrl;
  var promotionImageAlt;
  switch(shopName) {
    case 'wsk':
      promotionUrl = "/akcia-mesiaca/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/prechod-detail-wsk.jpg";
      promotionImageAlt = "Jarná úľava | Wilsondo.sk";
      //promotionUrl = "/akcie-zlavy/";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/wsk-maj.jpg";
      //promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
      //promotionUrl = "/vypredaj-skladov/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sale-detail-sk.png?v1";
      //promotionImageAlt = "Tukálny výpredaj | Wilsondo.sk";
      break;
    case 'whu':
      promotionUrl = "/honap-akcioja/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/prechod-detail-whu.jpg";
      promotionImageAlt = "Tavaszi megújulás | Wilsondo.hu";
      //promotionUrl = "/akciok-kedvezmenyek/";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/whu-maj.jpg";
      //promotionImageAlt = "Akciók kedvezmények | Wilsondo.hu";
      
      //promotionUrl = "/kiarusitas/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/sale-detail-hu.png?v1";
      //promotionImageAlt = "Tukális kiárusítás | Wilsondo.hu";
      break;
    case 'wcz':
      //promotionUrl = "/akce-mesice/";
      promotionUrl = "/detske-matrace/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/prechod-detail-wcz.jpg";
      promotionImageAlt = "Jarní úleva | Wilsondo.cz";
      //promotionUrl = "/vyprodej-skladu/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/sales-wcz.jpg?v1";
      //promotionImageAlt = "Velký výprodej skladu | Wilsondo.cz";
      break;
    case 'wro':
      //promotionUrl = "/oferta-lunii/";
      promotionUrl = "/saltele-pentru-copii/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/prechod-detail-wro.jpg";
      promotionImageAlt = "Ușurare de primăvară | Wilsondo.ro";
      //promotionUrl = "/vanzari-de-stoc/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/sales-wro.jpg?v1";
      //promotionImageAlt = "Mare lichidare de stoc | Wilsondo.ro";
      break;
    case 'wbg':
      promotionUrl = "/akcie-zlavy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
      //promotionUrl = "/vypredaj-skladov/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
      //promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'whr':
      //promotionUrl = "/akcija-mjeseca/";
      promotionUrl = "/djecji-madraci/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whr/prechod-detail-whr.jpg";
      promotionImageAlt = "Proljetno olakšanje | Wilsondo.hr";
      //promotionUrl = "/vypredaj-skladov/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
      //promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'wsi':
      //promotionUrl = "/akcija-meseca/";
      promotionUrl = "/otroske-vzmetnice/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsi/prechod-detail-wsi.jpg";
      promotionImageAlt = "Spomladansko olajšanje | Wilsondo.si";
      //promotionUrl = "/vypredaj-skladov/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
      //promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'wua':
      promotionUrl = "/akcie-zlavy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
      //promotionUrl = "/vypredaj-skladov/?order=bestseller";
      //promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
      //promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    default:
      return;
  }
  if ($(".social-buttons-wrapper").length) {
    var bannerPromotion = '<div class="banner-promotion-detail"><a href="' + promotionUrl + '"><img src="' + promotionImageUrl + '" alt="' + promotionImageAlt + '"></a></div>';
    $('.type-detail .social-buttons-wrapper').before(bannerPromotion);
  }
}

function shortDescriptionSpecificVisualChanges() {
  $('.p-short-description-block p').addClass('visual-changes-jam-mee');
}

function externalLinkingToWsk() {
  var urlMapping = {
    "/latovy-rost-160x70--250kg/" : "/rost-latovy-160x70--250kg/",
    "/hugo-pred-vyvysena-postel-biela/" : "/vyvysena-postel-hugo-pred-biela/",
    "/veronika-7-200x90-postel-s-pristelkou-a-uloznym-priestorom-2/" : "/lpw-007-200-x-90/",
    "/paula-2-200x90-poschodova-postel-z-masivu/" : "/poschodova-postel-paula-2-200x90-prirodna/",
    "/troj-poschodova-postel-petra-5-180x80-2/" : "/lpt-005-poschodova-postel-s-pristelkou-180x80/",
    "/postel-poschodova-paula-7-180x80-2/" : "/poschodova-postel-lp-007-180x80/",
    "/poschodove-postele-pre-deti-paula-7-200x90-2/" : "/poschodova-postel-lp-007-200x90/",
    "/poschodova-postel-s-pristelkou-petra-2-200x90/" : "/lpt-002-200x90-poschodova-postel-s-pristelkou/",
    "/poschodova-postel-s-pristelkou-petra-1-200x90/" : "/lpt-001-200x90-poschodova-postel-s-pristelkou/",
    "/chranic-na-matrac-160x90/" : "/chranic-na-matrac-160x90-cm/",
    "/sada-uloznych-boxov-pre-postel-mix-diego-pred-biely/" : "/sada-uloznych-boxov-pre-postel-mix-diego-pred-biele/",
    "/penovy-matrac-pretoria-180x80-2/" : "/penovy-matrac-pretoria-180x80/",
    "/matrac-babmbino-console-kokos-pohanka-160x70/" : "/matrac-bambino-console-kokos-pohanka-160x70/",
    "/matrac-kokos-pohanka-bambino-console-160x80-2/" : "/matrac-kokos-pohanka-bambino-console-160x80/",
    "/obojstranny-detsky-matrac-bamino-console-180x80/" : "/obojstranny-detsky-matrac-bambino-console-180x80/",
    "/obojstranny-kokosovo-pohankovy-matrac-bambino-console-190x80/" : "/kokosovo-pohankovy-matrac-bambino-console-190x80/",
    "/vrchny-matrac-200x80-visco-8-cm-2/" : "/vrchny-matrac-200x80-visco-8-cm/",
    "/vrchny-matrac-visco-200x90-8-cm-2/" : "/vrchny-matrac-visco-200x90-8-cm/",
    "/vrchny-matrac-visco-200x100-8-cm-2/" : "/vrchny-matrac-visco-200x100-8-cm/",
    "/vrchny-matrac-visco-200x120-8-cm-2/" : "/vrchny-matrac-visco-200x120-8-cm/",
    "/vrchny-matrac-visco-200x140-8-cm-2/" : "/vrchny-matrac-visco-200x140-8-cm/",
    "/vrchny-matrac-visco-200x160-8-cm-2/" : "/vrchny-matrac-visco-200x160-8-cm/",
    "/vrchny-matrac-visco-200x180-8-cm-2/" : "/vrchny-matrac-visco-200x180-8-cm/",
    "/visco-vrchny-matrac-200x200-8-cm-2/" : "/visco-vrchny-matrac-200x200-8-cm/",
    "/vrchny-matrac-z-latexu-200x80-4-cm-2/" : "/vrchny-matrac-z-latexu-200x80-4-cm/",
    "/vrchny-latexovy-matrac-z-latexu-200x90-4-cm-2/" : "/vrchny-latexovy-matrac-z-latexu-200x90-4-cm/",
    "/pristelkovy-matrac-z-latexu-200x100-4-cm-2/" : "/pristelkovy-matrac-z-latexu-200x100-4-cm/",
    "/vrchny-latexovy-matrac-200x120-4-cm-2/" : "/vrchny-latexovy-matrac-200x120-4-cm/",
    "/latexovy-vrchny-matrac-200x140-4-cm-2/" : "/latexovy-vrchny-matrac-200x140-4-cm/",
    "/vrchny-latexovy-matrac-200x160-4-cm-2/" : "/vrchny-latexovy-matrac-200x160-4-cm/",
    "/latexovy-vrchny-matrac-200x180-4-cm-2/" : "/latexovy-vrchny-matrac-200x180-4-cm/",
    "/latexovy-vrchny-matrac-200x200-4-cm-2/" : "/latexovy-vrchny-matrac-200x200-4-cm/",
    "/vrchny-matrac-z-pamatovej-peny-visco-200x80-4-cm-2/" : "/vrchny-matrac-z-pamatovej-peny-visco-200x80-4-cm/",
    "/vrchny-penovy-matrac-200x90-4-cm-2/" : "/vrchny-penovy-matrac-200x90-4-cm/",
    "/vrchny-matrac-z-pamatovej-peny-visco-200x100-4-cm-2/" : "/vrchny-matrac-z-pamatovej-peny-visco-200x100-4-cm/",
    "/vrchny-matrac-z-visco-pamatovej-peny-200x120-4-cm-2/" : "/vrchny-matrac-z-visco-pamatovej-peny-200x120-4-cm/",
    "/ortopedicky-vrchny-matrac-200x140-4--cm-2/" : "/ortopedicky-vrchny-matrac-200x140-4--cm/",
    "/vrchny-matrac-200x160-4-cm-2/" : "/vrchny-matrac-200x160-4-cm/",
    "/pristelkovy-matrac-z-visco-peny-200x180-4-cm-2/" : "/pristelkovy-matrac-z-visco-peny-200x180-4-cm/",
    "/vrchny-penovy-matrac-z-visco-peny-200x200-4-cm-2/" : "/vrchny-penovy-matrac-z-visco-peny-200x200-4-cm/",
    "/vrchny-latexovy-matrac-200x80-2-cm-2/" : "/vrchny-latexovy-matrac-200x80-2-cm/",
    "/vrchny-latexovy-matrac-200x90-2-cm-2/" : "/vrchny-latexovy-matrac-200x90-2-cm/",
    "/latexovy-pristelkovy-matrac-200x100-2-cm-3/" : "/latexovy-pristelkovy-matrac-200x100-2-cm/",
    "/vrchny-matrac-z-latexu-200x120-2-cm-2/" : "/vrchny-matrac-z-latexu-200x120-2-cm/",
    "/vrchny-matrac-z-prirodneho-latexu-200x140-2-cm-2/" : "/vrchny-matrac-z-prirodneho-latexu-200x140-2-cm/",
    "/latexovy-vrchny-matrac-200x160-2-cm-2/" : "/latexovy-vrchny-matrac-200x160-2-cm/",
    "/latexovy-matrac-200x180-2-cm-2/" : "/latexovy-matrac-200x180-2-cm/",
    "/vrchny-matrac-z-latexu-200x200-2-cm-2/" : "/vrchny-matrac-z-latexu-200x200-2-cm/",
    "/matrac-pre-deti-adriana-160x80/" : "/detsky-matrac-adriana-160x80/",
    "/corela-matrac-s-latexom-a-hr-penou-180x80-2/" : "/corela-matrac-s-latexom-a-hr-penou-180x80/",
    "/priedusny-latexovy-matrac-s-hr-penou-180x90-corela-2/" : "/priedusny-latexovy-matrac-s-hr-penou-180x90-corela/",
    "/pevny-priedusny-latexovy-matrac-corela-190x90-2/" : "/pevny-priedusny-latexovy-matrac-corela-190x90/",
    "/priedusny-latexovy-matrac-corela-200x90-2/" : "/priedusny-latexovy-matrac-corela-200x90/",
    "/matrac-lugano-200x90-s-pamatovou-visco--lenivou--penou/" : "/matrac-lugano-200x90-s-pamatovou--lenivou--penou/",
    "/matrac-lujza-s-hr-penou-180x80-2/" : "/matrac-lujza-s-hr-penou-180x80/",
    "/lujza-matrac-z-polyuretanovej-peny-s-hr-penou-180x90/" : "/lujza-penovy-matrac-s-hr-penou-180x90/",
    "/pikolino-matrac-160x80-s-kokosom-2/" : "/pikolino-matrac-160x80-s-kokosom/",
    "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x80-2/" : "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x80/",
    "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x90/" : "/detsky-matrac-pikolino-180x90/",
    "/pikolino-kokosovo-latexovy-matrace-200x90/" : "/pikolino-kokosovo-priedusny-latexovy-matrace-200x90/",
    "/sofia-kokosovy-matrac-pre-deti-160x70-2/" : "/sofia-kokosovy-matrac-pre-deti-160x70/",
    "/sofia-detsky-kokosovy-matrac-180x80-2/" : "/sofia-detsky-kokosovy-matrac-180x80/",
    "/sofia-penovy-matrac-pre-deti-180x90-2/" : "/sofia-penovy-matrac-pre-deti-180x90/",
    "/sofia-matrac-pre-deti-so-studenou-penou-190x90/" : "/sofia-matac-pre-deti-so-studenou-penou-190x90/",
    "/matrac-s-kokosom-sandra-200x80/" : "/kokosovy-matrac-sandra-200x80/",
    "/matrac-s-kokosom-sandra-200x90/" : "/kokosovy-matrac-sandra-200x90/",
    "/matrac-s-kokosom-sandra-200x140/" : "/kokosovy-matrac-sandra-200x140/",
    "/matrac-s-kokosom-sandra-200x160/" : "/kokosovy-matrac-sandra-200x160/",
    "/matrac-s-kokosom-sandra-200x180/" : "/kokosovy-matrac-sandra-200x180/",
    "/matrac-s-kokosom-sandra-200x120/" : "/kokosovy-matrac-sandra-200x120/",
    "/gina-tastickovy-matrac-200x80/" : "/gina-matrac-s-tastickovymi-pruzinami-200x80/",
    "/gina-tastickovy-matrac-200x90/" : "/gina-matrac-s-tastickovymi-pruzinami-200x90/",
    "/tastickovy-matrac-s-kokosom-gina-200x120/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x120/",
    "/tastickovy-matrac-s-kokosom-gina-200x140/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x140/",
    "/tastickovy-matrac-s-kokosom-gina-200x160/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x160/",
    "/matrac-s-kokosom-s-tastickami-gina-200x180/" : "/kokosovy-matrac-s-tastickovymi-pruzinami-gina-200x180/",
    "/detsky-matrac-bambino-candy-160x90-2/" : "/matrac-bambino-candy-160x90/",
    "/multifunkcna-poschodova-postel-party-14/" : "/multifunkcna-poschodova-postel-party-14-viac-farieb/",
    "/farebne-uchytky-pre-multifunkcne-poschodove-postele-party/" : "/uchytky-pre-multifunkcne-postele-party/",
    "/multifunkcna-poschodova-postel-toledo-1-viac-farieb/" : "/multifunkcna-postel-toledo-1/",
    "/uchyty-pre-multifunkcnu-postel-toledo/" : "/uchytky-pre-multifunkcnu-postel-toledo/",
    "/multifunkcna-poschodova-postel-toledo-2-viac-farieb/" : "/multifunkcna-postel-toledo-2-viac-farieb/",
    "/multifunkcna-oschodova-postel-max-3-rozne-farby/" : "/multifunkcna-poschodova-postel-max-3-viac-farieb/",
    "/detske-bavlnene-obliecky-100x135-40x60-mala-panda/" : "/detske-obliecky-mala-panda-100-135-40-60/",
    "/matrac-adriana-140x70/" : "/penovy-matrac-adriana-140x70/",
    "/matrac-bambino-console-kokos-pohanka-140x70/" : "/detsky-matrac-bambino-console-s-kokosom-140x70/",
    "/pikolino-detsky-priedusny-latexovy-matrac-140x70/" : "/pikolino-matrac-s-kokosom-a-latexom-140x70/",
    "/sofia-kokosovy-matrac-pre-deti-140x70/" : "/kokosovy-matrac-pre-deti-sofia-140x70/",
    "/paula-2-200x90-poschodova-postel-z-masivu-grafit/" : "/poschodova-postel-paula-2-200x90-grafit/",
    "/paula-2-200x90-poschodova-postel-z-masivu-biela/" : "/poschodova-postel-paula-2-200x90-biela/",
    "/detske-obliecky-nebi-120x90/" : "/detske-obliecky-nebi-120x90-2-dielne/",
    "/detske-obliecky-pegas-135x100/" : "/detske-obliecky-pegas-135x100-2-dielne/",
    "/bavlnene-obliecky-140x200-70x90-little-fairy/" : "/detske-bavlnene-obliecky-140x200-70x90-little-fairy-1/",
    "/bavlnene-obliecky-140x200-70x90-fireman-sam/" : "/detske-bavlnene-obliecky-140x200-70x90-fireman-sam/",
    "/pruzinovy-matrac-200x85/" : "/pruzinovy-matrac-85x200/",
    "/latovy-rost-90x200--120-kg-osoba/" : "/latovy-rost-90x200-120-kg-osoba/",
    "/lamelovy-rost-80x200--120kg-osoba/" : "/lamelovy-rost-80x200-120kg-osoba/",
    "/plachta-frote-120x60-2/" : "/plachta-frote-120x60/",
    "/plachta-frote-140x70-2/" : "/plachta-frote-140x70/",
    "/plachta-frote-160x70-2/" : "/plachta-frote-160x70/",
    "/plachta-frote-160x80-2/" : "/plachta-frote-160x80/",
    "/plachta-frote-180x80-2/" : "/plachta-frote-180x80/",
    "/plachta-frote-180x90-2/" : "/plachta-frote-180x90/",
    "/plachta-frote-190x80-2/" : "/plachta-frote-190x80/",
    "/plachta-frote-190x90-2/" : "/plachta-frote-190x90/",
    "/plachta-frote-200x80-2/" : "/plachta-frote-200x80/",
    "/plachta-frote-200x90-2/" : "/plachta-frote-200x90/",
    "/plachta-frote-200x100-2/" : "/plachta-frote-200x100/",
    "/plachta-jersey-160x70-2/" : "/plachta-jersey-160x70/",
    "/plachta-jersey-160x80-2/" : "/plachta-jersey-160x80/",
    "/plachta-jersey-180x80-2/" : "/plachta-jersey-180x80/",
    "/plachta-jersey-180x90-2/" : "/plachta-jersey-180x90/",
    "/plachta-jersey-190x80-2/" : "/plachta-jersey-190x80/",
    "/plachta-jersey-190x90-2/" : "/plachta-jersey-190x90/",
    "/plachta-jersey-200x80-2/" : "/plachta-jersey-200x80/",
    "/plachta-jersey-200x90-2/" : "/plachta-jersey-200x90/",
    "/plachta-jersey-200x100-2/" : "/plachta-jersey-200x100/",
    "/plachta-jersey-200x120-2/" : "/plachta-jersey-200x120/",
    "/plachta-jersey-200x200-2/" : "/plachta-jersey-200x200/",
  };
  var currentURL = window.location.href;
  var url = new URL(currentURL);
  var path = url.pathname;
  var newURL = "https://www.wilsondo.sk" + path;

  // Check if current URL exists in the list of keys in the object
  if (urlMapping.hasOwnProperty(path)) {
      newURL = "https://www.wilsondo.sk" + urlMapping[path];
  }
  // Create link and attach it before the add-to-card element
  var newLinkHTML = '<div class="external_linking_to_wsk"><a href="' + newURL +'?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking">Kúpiť produkt na wilsondo.sk</a></div>';

  var addToCartElement = $('.p-info-wrapper .add-to-cart');
    if (addToCartElement.length) {
      addToCartElement.before(newLinkHTML);
  }
}

function externalLinkingToWhu() {
  // Identical in shape to externalLinkingToWsk(), but kept as a separate
  // method for whu so it can be removed independently once eag is retired.
  var urlMapping = {
    "/butorok/" : "/butor/",
    "/matracok/" : "/matracok/",
    "/lakaskiegeszitok/" : "/lakaskiegeszitok/",
    "/gyerekeknek/" : "/gyerekeknek/",
    "/gyerekagyak-leesesgatloval/" : "/leesesgatlos-gyerekagyak/",
    "/haziko-gyerekagyak/" : "/haziko-agyak/",
    "/agyak-lanyoknak/" : "/agyak-lanyoknak/",
    "/agyak-fiuknak/" : "/agyak-fiuknak/",
    "/galeriaagy/" : "/galeriaagyak/",
    "/multifunkcios-agyak/" : "/multifunkcios-agyak/",
    "/agyak-kihuzhato-vendegaggyal/" : "/kihuzhato-gyerekagyak/",
    "/2-szemelyes-emeletes-agyak/" : "/2-szemelyes-emeletes-agyak/",
    "/emeletes-agyak-potaggyal/" : "/3-szemelyes-emeletes-agyak/",
    "/kiszelesitett-emeletes-agyak/" : "/emeletes-agyak-kiszelesitett-also-fekhellyel/",
    "/emeletes-agy-iroasztallal/" : "/emeletes-agyak-iroasztallal/",
    "/tobbfunkcios-agyak/" : "/multifunkcios-emeletes-agyak/",
    "/gyerek-iroasztalok/" : "/gyerek-iroasztalok/",
    "/ejjeliszekrenyek/" : "/ejjeliszekrenyek/",
    "/matracok-a-kisagyba-60x120/" : "/60x120-matrac/",
    "/70x140-matrac/" : "/70x140-matrac/",
    "/80x160-matrac/" : "/80x160-matrac/",
    "/80x180-matrac/" : "/80x180-matrac/",
    "/90x180-matrac/" : "/90x180-matrac/",
    "/80x190-matrac/" : "/80x190-matrac/",
    "/90x190-matrac/" : "/90x190-matrac/",
    "/gyerekmatracok-195x90-cm-matracok-90x195-cm/" : "/gyerekmatracok-195x90-cm/",
    "/gyerekmatracok-200x85-cm-matracok-85x200-cm/" : "/85x200-gyerekmatrac/",
    "/gyerekmatracok-200x80-cm/" : "/80x200-gyerekmatrac/",
    "/gyerekmatracok-200x90-cm/" : "/90x200-gyerekmatrac/",
    "/gyerekmatracok-200x100-cm/" : "/gyerekmatracok-200x100-cm/",
    "/gyerekmatracok-200x120-cm/" : "/gyerekmatracok-200x120-cm-2/",
    "/gyerekmatracok-200x140-cm/" : "/gyerekmatracok-200x140-cm/",
    "/gyerek-atipikus-meretek/" : "/gyerek-atipikus-meretek/",
    "/memoriahabos-fedomatracok/" : "/memoriahabos-fedomatracok/",
    "/fedomatracok-80x200/" : "/fedomatracok-80x200/",
    "/fedomatracok-90x200/" : "/fedomatracok-90x200/",
    "/fedomatracok-100x200/" : "/fedomatracok-100x200/",
    "/fedomatracok-120x200/" : "/fedomatracok-120x200/",
    "/fedomatracok-140x200/" : "/fedomatracok-140x200/",
    "/fedomatracok-160x200/" : "/fedomatracok-160x200/",
    "/fedomatracok-180x200/" : "/fedomatracok-180x200/",
    "/fedomatracok-200x200/" : "/fedomatracok-200x200-2/",
    "/matracok-a-babaagyba-es-a-kisagyba/" : "/matracok-a-babaagyba-es-a-kisagyba/",
    "/matracok-a-bolcsobe/" : "/matracok-a-bolcsobe/",
    "/gyerekmatracok-120x70-matracok-70x120-cm/" : "/gyerekmatracok-120x70-cm/",
    "/gyerekmatracok-140x80-cm/" : "/gyerekmatracok-140x80-cm/",
    "/gyerekmatracok-150x80-cm/" : "/gyerekmatracok-150x80-cm/",
    "/70x160-matrac/" : "/gyerekmatracok-160x70-cm/",
    "/90x160-matrac/" : "/gyerekmatracok-160x90-cm/",
    "/80x170-matrac/" : "/gyerekmatracok-170x80-cm/",
    "/boxspring-agyak/" : "/boxspring-agyak/",
    "/egyszemelyes-agyak/" : "/egyszemelyes-agyak/",
    "/emeletes-agyak/" : "/emeletes-agyak/",
    "/gyerekagyak/" : "/gyerekagyak/",
    "/fem-agyak/" : "/fem-agyak/",
    "/fa-agyak/" : "/fa-agyak/",
    "/kihuzhato-agyak/" : "/kihuzhato-agyak/",
    "/agyracsok-meret-szerint/" : "/agyracsok-2/",
    "/tartozekok-az-agyakhoz/" : "/tartozekok-az-agyakhoz/",
    "/agyvedok/" : "/leesesgatlok/",
    "/gyerekszoba-butor/" : "/gyerekszoba-butor/",
    "/agyak/" : "/agyak/",
    "/komodok/" : "/komodok/",
    "/szekrenyek/" : "/szekrenyek/",
    "/gyerekszoba-dekoraciok/" : "/gyerekszoba-dekoraciok/",
    "/jatektarolok/" : "/jatektarolok/",
    "/matracok-meret-szerint/" : "/meret-szerint/",
    "/matracok-osszetetel-szerint/" : "/matracok-osszetetel-szerint/",
    "/akcio-matracok-1-1-2/" : "/1-1-matracok-akcio/",
    "/gyerekmatracok/" : "/gyerekmatracok/",
    "/fedomatrac/" : "/fedomatracok/",
    "/ortoped-matracok/" : "/ortoped-matracok/",
    "/meretre-gyartott-matracok/" : "/egyedi-meretre-gyartott-matracok/",
    "/kiegeszitok-a-matracokhoz/" : "/kiegeszitok-a-matracokhoz/",
    "/olcso-matrac/" : "/olcso-matrac/",
    "/lampak-a-gyerekszobaba/" : "/lampak-a-gyerekszobaba/",
    "/matracvedok/" : "/matracvedok/",
    "/lepedok-2/" : "/lepedok-2/",
    "/80x200-matrac/" : "/matracok-80x200-cm/",
    "/90x200-matrac/" : "/matracok-90x200-cm/",
    "/100x200-matrac/" : "/matracok-100x200-cm/",
    "/120x200-matrac/" : "/matracok-120x200-cm/",
    "/140x200-matrac/" : "/matracok-140x200-cm/",
    "/160x200-matrac/" : "/matracok-160x200-cm/",
    "/180x200-matrac/" : "/matracok-180x200-cm/",
    "/200x200-matrac/" : "/matracok-200x200-cm/",
    "/habszivacs-matracok/" : "/habszivacs-matracok/",
    "/taskarugos-matracok/" : "/taskarugos-matracok/",
    "/memoriahabos-matracok/" : "/memoriahabos-matracok/",
    "/kokuszmatracok/" : "/kokuszmatracok/",
    "/rugos-matracok/" : "/rugos-matracok/",
    "/latex-matracok/" : "/latex-matracok/",
    "/gyerekagyak-es-babaagyak/" : "/gyerekagyak-es-babaagyak/",
    "/emeletes-agyak-2/" : "/emeletes-agyak-2/",
    "/gyerekszobak/" : "/gyerekszobak/",
    "/gyerekmatracok-3/" : "/gyerekmatracok-2/",
    "/gyerekszoba-szekrenyek-2/" : "/gyerekszoba-szekrenyek-2/",
    "/komodok-es-pelenkazo-pultok/" : "/komodok-es-pelenkazo-pultok/",
    "/polcos-szekrenyek-es-polcok-a-gyerekszobaba/" : "/polcos-szekrenyek-es-polcok-a-gyerekszobaba/",
    "/gyerek-iroasztalok-es-szekek/" : "/gyerek-iroasztalok-es-szekek/",
    "/lanyos-gyerekszobak/" : "/lanyos-gyerekszobak/",
    "/filip-butor-kollekcio/" : "/filip-butor-kollekcio/",
    "/komodok-a-gyerekszobaba/" : "/komodok-a-gyerekszobaba/",
    "/gardrobszekrenyek-a-haloszobaba/" : "/haloszoba-szekrenyek/",
    "/gyerekszoba-szekrenyek/" : "/gyerekszoba-szekrenyek/",
    "/eloszoba-szekrenyek/" : "/eloszoba-szekrenyek/",
    "/lakastextil/" : "/lakastextil/",
    "/dekoraciok/" : "/dekoraciok/",
    "/lampak/" : "/lampak/",
    "/falpanel/" : "/falpanel/",
    "/gyerekszoba-butor-2/" : "/gyerekszoba-butor-2/",
    "/gyerekmatracok-2/" : "/gyerekmatracok-3/",
    "/gyerekszoba-textilek/" : "/gyerekszoba-textilek/",
    "/jatekok/" : "/jatekok/",
    "/gyerekagyak-2/" : "/gyerekagyak-2/",
    "/polcos-szekrenyek-a-gyerekszobaba/" : "/polcos-szekrenyek-a-gyerekszobaba/",
    "/lepedok/" : "/lepedok/",
    "/agynemuhuzatok/" : "/agynemuhuzatok/",
    "/gyerekszoba-textilek-2/" : "/gyerek-textilek/",
    "/gyerek-agynemuhuzatok/" : "/gyerek-agynemuhuzatok/",
    "/ketajtos-ruhasszekrenyek/" : "/ketajtos-ruhasszekrenyek/",
    "/kiegeszitok-a-szekrenyekhez/" : "/kiegeszitok-a-szekrenyekhez/",
    "/boxspring-agyak-2/" : "/boxspring-agyak-2/",
    "/gyerekmatracok-175x80-cm/" : "/gyerekmatracok-175x80-cm/",
    "/lamellas-agyracsok/" : "/lamellas-agyracsok/",
    "/leces-agyracsok/" : "/leces/",
    "/egyeb-matracok/" : "/egyeb-matracok/",
    "/gyerekmatracok-meret-szerint/" : "/gyerekmatracok-meret-szerint/",
    "/atipikus-matracok/" : "/atipikus-matracok/",
    "/sluzby-2/" : "/sluzby-2/",
  };
  var currentURL = window.location.href;
  var url = new URL(currentURL);
  var path = url.pathname;
  var newURL = "https://www.wilsondo.hu" + path;

  // Check if current URL exists in the list of keys in the object
  if (urlMapping.hasOwnProperty(path)) {
      newURL = "https://www.wilsondo.hu" + urlMapping[path];
  }
  // Create link and attach it before the add-to-card element
  var newLinkHTML = '<div class="external_linking_to_whu"><a href="' + newURL +'?utm_source=emeletes-agyak&utm_medium=referral&utm_campaign=external_linking">Termék megvásárlása a wilsondo.hu-n</a></div>';

  var addToCartElement = $('.p-info-wrapper .add-to-cart');
    if (addToCartElement.length) {
      addToCartElement.before(newLinkHTML);
  }
}

function disableSheetMixPurchase() {
  var urlMix;
  var urlSheets;
  var textSheets;
  switch(lang) {
    case 'sk':
      urlMix = '/celorocny-vankus-ecomax-2-ks/';
      urlSheets = '/vankuse/';
      textSheets = 'Pozrite si kompletnú ponuku vankúšov.';
      break;
    case 'hu':
      urlMix = '/ecomax-egeszeves-parna-2-ks/';
      urlSheets = '/parnak-es-kisparnak/';
      textSheets = 'Tekinsd meg teljes párna kínálatunkat.';
      break;
    default:
      return;
  }

  if (window.location.href.includes(urlMix)) {
    var addToCartButton = $('.p-info-wrapper .add-to-cart');
    var newLinkHTML = '<div class="gift_internal_link"><a href="'+ urlSheets +'">' + textSheets + '</a></div>';

    if (addToCartButton.length) {
      addToCartButton.hide();
      addToCartButton.before(newLinkHTML);
    }
  }
}

function addMOCLabel() {
  var labelText, tooltipText, prefixText;

  switch (lang) {
    case 'sk':
      labelText = "MOC";
      tooltipText = "Toto je výrobcom doporučená maloobchodná cena.";
      prefixText = "od ";
      break;
    case 'hu':
      labelText = "kisker ár";
      tooltipText = "Ez a gyártó által ajánlott kiskereskedelmi ár.";
      prefixText = "-tól";
      break;
    case 'cs':
      labelText = "MOC";
      tooltipText = "Toto je výrobcem doporučená maloobchodní cena.";
      prefixText = "od ";
      break;
    case 'ro':
      labelText = "PRP";
      tooltipText = "Acesta este prețul recomandat de vânzare cu amănuntul de către producător.";
      prefixText = "de la ";
      break;
    default:
      return;
  }

  const $priceContainer = $(".p-info-wrapper .p-short-description-block");
  if (!$priceContainer.length) return $(".moc-label").remove();

  const $wMocPrice = $priceContainer.find(".w-moc-price");
  if ($wMocPrice.length === 0 || $wMocPrice.find("span").length === 0) {
    return $(".moc-label").remove();
  }

  const $selects = $("select.hidden-split-parameter");
  let noVariantSelected = false;

  $selects.each(function () {
    const selected = $(this).find("option:selected").data("index");
    if (selected === 0 || selected === "0") {
      noVariantSelected = true;
    }
  });

  let mocPrice = "";

  function getLowestPrice() {
    let lowest = null;
    let priceText = "";

    $wMocPrice.find("span").each(function () {
      const text = $(this).text().trim();
      const num = parseFloat(text.replace(/\s/g, "").replace(/[^\d,\.]/g, "").replace(",", "."));
      if (!isNaN(num) && (lowest === null || num < lowest)) {
        lowest = num;
        priceText = text;
      }
    });

    if (!priceText) return "";
    return lang === "hu" ? priceText + prefixText : prefixText + priceText;
  }

  if (noVariantSelected) {
    mocPrice = getLowestPrice();
  } else {
    const $visibleSKU = $(".parameter-dependent")
      .not(".no-display")
      .not(".noDisplay")
      .not(".default-variant");

    if ($visibleSKU.length) {
      const activeSKU = $visibleSKU.first().text().trim();
      const $price = $wMocPrice.find(`span[data-sku="${activeSKU}"]`);
      if ($price.length) {
        mocPrice = $price.text().trim();
      } else {
        // Variant selected without MOC
        return $(".moc-label").remove();
      }
    } else {
      mocPrice = getLowestPrice();
    }
  }

  // If no MOC, remove label
  if (!mocPrice) return $(".moc-label").remove();

  $(".moc-label").remove();

  $(".p-final-price-wrapper").each(function () {
    const $moc = $(`
      <div class="moc-label">
        <span class="moc-label-text">${labelText} </span>
        <span class="moc-price">${mocPrice}</span>
        <span class="moc-tooltip-icon">i
          <div class="tooltiptext">${tooltipText}</div>
        </span>
      </div>
    `);
    $moc.insertAfter($(this));
  });
}

function initYotpoReviews() {
  if (typeof yotpoWidgetTab === 'undefined' || typeof yotpoWidgetStars === 'undefined' || typeof yotpoHeadline === 'undefined') return;

  // sku 
  function getSku() {
    sku = $('.p-code span').not('.p-code-label').first().text().trim();
    if (sku) return sku;
  }

  let productSku = getSku();
  if (!productSku) return;
  productSku = productSku.replace(/\//g, '_');

  // tabs
  function ensureTabsUl() {
    return $('#p-detail-tabs').length
      ? $('#p-detail-tabs')
      : $('ul.p-detail-tabs, ul.shp-tabs.p-detail-tabs, ul.shp-tabs').first();
  }

  // content
  function findContentContainer($ul) {
    return $ul.next('.tab-content').length
      ? $ul.next('.tab-content')
      : $('.p-detail-tabs-content, .shp-tabs-content, .tab-content').first();
  }

  const $ul = ensureTabsUl();
  if (!$ul.length) return;
  const $content = findContentContainer($ul);
  if (!$content.length) return;

  // hodnotenie tab
  function ensureRatingTabExists() {
    let $li = $ul.find('a[href="#ratingTab"]').closest('li');
    if (!$li.length) {
      $li = $(`
        <li class="shp-tab" data-width="0">
          <a href="#ratingTab" class="shp-tab-link" role="tab" data-toggle="tab">${yotpoHeadline}</a>
        </li>
      `);
      $ul.append($li);
    } else {
      $li.find('a[href="#ratingTab"]').text(yotpoHeadline);
    }

    let $panel = $('#ratingTab');
    if (!$panel.length) {
      $panel = $(`<div id="ratingTab" class="tab-pane" role="tabpanel" aria-labelledby="tab-rating-link"></div>`);
      $content.append($panel);
    }
    return $panel;
  }

  const $ratingPanel = ensureRatingTabExists();

  // hviezdičky hore v info wrapperi
  (function insertStarsTop() {
    const $wrapper = $('.p-info-wrapper-content').first();
    if (!$wrapper.length) return;
    if ($wrapper.find('.yotpo-widget-instance.yotpo-stars-widget').length) return;
    const $stars = $(`
      <div class="yotpo-widget-instance yotpo-stars-widget"
           style="display:none"
           data-yotpo-instance-id="${yotpoWidgetStars}"
           data-yotpo-product-id="${productSku}"></div>
    `);
    $wrapper.prepend($stars);
  })();

  // widget do rating tabu
  if ($ratingPanel.find('.yotpo-widget-instance.yotpo-tab-widget').length === 0) {
    $ratingPanel.append(
      `<div class="yotpo-widget-instance yotpo-tab-widget"
            data-yotpo-instance-id="${yotpoWidgetTab}"
            data-yotpo-product-id="${productSku}"></div>`
    );
  }

  // polling na počet recenzií
  let tries = 0;
  const maxTries = 30;
  const poll = setInterval(() => {
    const $starsRoot = $(`.yotpo-widget-instance.yotpo-stars-widget[data-yotpo-product-id="${productSku}"]`);
    let $count = $starsRoot.find('.yotpo-sr-bottom-line-text');
    if (!$count.length) $count = $('.yotpo-sr-bottom-line-text').first();

    if ($count.length) {
      const text = $count.text().trim();
      const m = text.match(/\((\d+)\)/);
      const reviewCount = m ? parseInt(m[1], 10) : 0;

      const $tabLi = $ul.find('a[href="#ratingTab"]').closest('li');
      if (reviewCount === 0) {
        $tabLi.hide();
        $ratingPanel.find('.yotpo-tab-widget').remove();
        $('.yotpo-bottom-line-scroll-panel').css('pointer-events', 'none');
        $(`.yotpo-widget-instance.yotpo-stars-widget[data-yotpo-product-id="${productSku}"]`).remove();
      } else {
        $(`.yotpo-widget-instance.yotpo-stars-widget[data-yotpo-product-id="${productSku}"]`).css('display', '');
      }
      clearInterval(poll);
    }

    if (++tries >= maxTries) clearInterval(poll);
  }, 300);

  // klik na scroll na hodnotenie
  $(document).off('click.initYotpoScroll').on('click.initYotpoScroll', '.yotpo-bottom-line-scroll-panel', function (e) {
    e.preventDefault();
    const $link = $ul.find('a[href="#ratingTab"].shp-tab-link').first();
    const $panel = $('#ratingTab');
    if (!$panel.length || !$link.length) return;

    const go = () => $('html, body').animate({ scrollTop: $panel.offset().top }, 300);

    if (!$panel.is(':visible')) {
      $link.trigger('click');
      setTimeout(go, 200);
    } else {
      go();
    }
  });

  // očistiť text tabu od zátvoriek
  $ul.find('a[href="#ratingTab"].shp-tab-link').each(function () {
    const $a = $(this);
    const cleaned = $a.text().replace(/\s*\([^)]*\)/g, '').trim();
    if (cleaned) $a.text(cleaned);
  });
}

function giftReposition() {
  const $gifts = $('.p-gifts-wrapper');
  const $target = $('.p-info-wrapper-content');
  const $detailInner = $('.p-detail-inner');

  // gifts alebo badge
  const hasGifts = (
    ($gifts.length && $gifts.children().length > 0) ||
    $('.product-top .flag.flag-xy-discount').length > 0
  );

  var topBannerText;
  var topBannerUrl;
  var topBannerCta;

  switch (lang) {
    case 'sk':
      topBannerText = 'Kúpte si tento produkt a získajte od Wilsonda DARČEK! Viac ';
      topBannerUrl = '/podmienky-ziskania-darceka';
      topBannerCta = 'v podmienkach získania darčeka.';
      break;
    case 'hu':
      topBannerText = 'Vásárolja meg ezt a terméket és tegyen szert egy AJÁNDÉKRA a Wilsondotól! Tudjon meg többet ';
      topBannerUrl = '/az-ajandek-megszerzesenek-feltetelei/';
      topBannerCta = 'az ajándék megszerzésének feltételeiről.';
      break;
    case 'cs':
      topBannerText = 'Kupte si tento produkt a získejte od Wilsonda DÁREK! Více ';
      topBannerUrl = '/podminky-ziskani-darku/';
      topBannerCta = 'v podmínkách získání dárku.';
      break;
    case 'ro':
      topBannerText = 'Cumpărați acest produs și primiți un CADOU de la Wilsondo! ';
      topBannerUrl = '/conditii-pentru-obtinerea-cadoului/';
      topBannerCta = 'Mai multe detalii în condițiile de obținere a cadoului.';
      break;
    case 'bg':
      topBannerText = 'Купете този продукт и вземете БЕЗПЛАТЕН ПОДАРЪК от Wilsondo! ';
      topBannerUrl = '/';
      topBannerCta = 'Вижте правилата и условията за подробности.';
      break;
    case 'hr':
      topBannerText = 'Kupite ovaj proizvod i dobit ćete BESPLATNI POKLON od Wilsonda! ';
      topBannerUrl = '/uvjeti-dobivanja-poklona/';
      topBannerCta = 'Detalje potražite u uvjetima i odredbama.';
      break;
    case 'sl':
      topBannerText = 'Kupite ta izdelek in prejmite od Wilsonda DARILO! Več preberite ';
      topBannerUrl = '/pogoji-za-prejem-darila/';
      topBannerCta = 'v pogojih za prejem darila.';
      break;
    default:
      return;
  }

  if ($gifts.length && $target.length) {
    $gifts.appendTo($target);
  }

  setTimeout(() => {
    // ak už nejaký banner existuje
    const bannerExists = $('.top-banner-plugin-gift').length > 0;

    if (hasGifts && !bannerExists && $detailInner.length) {
      const $banner = $(`
        <div class="top-banner-plugin-gift custom">
          <p>
            ${topBannerText}
            <a href="${topBannerUrl}">${topBannerCta}</a>
          </p>
        </div>
      `);
      $banner.insertBefore($detailInner);
    }
  }, 300);
}

function moveShoptetBenefits() {
  setTimeout(() => {
    const $typeDetail = $('.type-detail');
    const $original = $typeDetail.find('.benefitBanner');
    if (!$original.length) return;

    const $desktopClone = $original.clone().addClass('desktop');
    const $mobileClone = $original.clone().addClass('mobile');

    $typeDetail.find('.product-top .p-image-wrapper').append($desktopClone);
    $typeDetail.find('.product-top .p-info-wrapper').append($mobileClone);

    $original.remove();
  }, 500);
}

function addImageBadge() {
  // ak nie je definovaný jazyk alebo badge dáta, nespustíme funkciu
  if (!lang || typeof flagImages === 'undefined') return;

  const waitForSlide = (callback, tries = 10) => {
    const $firstSlide = $('.carousel__slide').first();
    if ($firstSlide.length) return callback($firstSlide);
    if (tries <= 0) return;
    setTimeout(() => waitForSlide(callback, tries - 1), 200);
  };

  waitForSlide(($firstSlide) => {
    const $allFlags = $('.p-detail-info .flags .flag');
    if (!$allFlags.length) return;

    // Zoradíme všetky flagy podľa priority (gift1 > gift2/3 > badge)
    const sortedFlags = $allFlags.toArray().sort((a, b) => {
      const getPriority = (el) => {
        const cls = Array.from(el.classList).find(c =>
          c.startsWith('flag-gift-') || c.startsWith('flag-badge-')
        );
        if (!cls) return 99;
        if (cls === 'flag-gift-1') return 1;
        if (cls.startsWith('flag-gift-')) return 2;
        if (cls.startsWith('flag-badge-')) return 3;
        return 99;
      };
      return getPriority(a) - getPriority(b);
    });

    for (const flagEl of sortedFlags) {
      const classList = Array.from(flagEl.classList);
      const badgeClass = classList.find(cls =>
        (cls.startsWith('flag-badge-') || cls.startsWith('flag-gift-')) &&
        classList.includes('flag') &&
        classList.length === 2
      );

      if (!badgeClass) continue;
      if ($firstSlide.find(`.product-badge-img.${badgeClass}`).length) continue;

      const badgeEntry = flagImages[badgeClass];
      if (!badgeEntry) break;

      const imgUrl = badgeEntry[lang];
      if (!imgUrl || imgUrl.trim() === '') break;

      const $badgeImg = $('<img>', {
        src: imgUrl,
        alt: badgeClass,
        class: `product-badge-img ${badgeClass}`,
        loading: 'lazy',
      });

      $firstSlide.append($badgeImg);
      break; // zobrazíme len jeden badge podľa priority
    }
  });
}

function initRichSnippets() {
  if (shopName !== 'wro') return;
  
  const targetSKU = "WX70626/AV";
  const $productWrapper = $('.p-detail-inner');
  if (!$productWrapper.length) return;

  const currentSKU = $('.parameter-dependent').text().trim();

  const $rating = $('.yotpo-bottom-line-score');
  const $count  = $('.yotpo-sr-bottom-line-text');

  const ratingValue = parseFloat($rating.text().trim());
  const text = $count.first().text().trim();
  const reviewCount = parseInt(text.replace(/[()]/g, ''), 10);

  const productName = $productWrapper.find('.p-detail-inner-header h1').text().trim();

  const data = {
    "@context": "http://schema.org",
    "@type": "Product",
    sku: targetSKU,
    name: productName || "Produkt",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue,
      reviewCount,
      bestRating: 5,
      worstRating: 1
    }
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data, null, 2);
  document.body.appendChild(script);
}

function addBadgePexesoDetail() {
  var imgSrc;

  switch (lang) {
    case 'sk':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/badge-pexeso.png';
      break;
    case 'hu':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/badge-pexeso.png';
      break;
    case 'cs':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/badge-pexeso.png';
      break;
    case 'ro':
      imgSrc = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/badge-pexeso.png";
      break;
    case 'hr':
      imgSrc = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whr/badge-pexeso.png";
      break;
    case 'sl':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsi/badge-pexeso.png';
      break;
    default:
      return;
  }

  setTimeout(function () {
    // Pexeso len pre produkty s xy-discount
    var hasBadgeFlag = document.querySelector('.product-top .flag.flag-xy-discount');
    if (!hasBadgeFlag) return;

    var firstSlide = document.querySelector('.carousel__slide');
    if (!firstSlide) return;

    // ak je GIFT badge, pexeso vôbec nepridávame
    var giftBadge = firstSlide.querySelector('.product-badge-img[class*="flag-gift-"]');
    if (giftBadge) return;

    // ak je tam len BADGE (flag-badge-XXX), skryjeme ho
    var normalBadges = firstSlide.querySelectorAll('.product-badge-img[class*="flag-badge-"]');
    normalBadges.forEach(function (badge) {
      badge.style.display = 'none';
    });

    // 4) pridáme Pexeso badge
    var img = document.createElement('img');
    img.className = 'product-badge-img pexeso-badge';
    img.src = imgSrc;
    img.alt = 'Pexeso';

    firstSlide.appendChild(img);
  }, 300);
}

// Low-priority promotional badge (flag-badge-5) for product detail — JS-only,
// never assigned in admin. Renders only when no other gift/badge/pexeso is on
// the first carousel slide and the displayed price is above the price threshold
// configured per page in admin.
function addBadge5LowPriorityDetail() {
  if (!lang || typeof flagImages === 'undefined') return;

  var badgeEntry = flagImages['flag-badge-5'];
  if (!badgeEntry) return;
  var imgUrl = badgeEntry[lang];
  if (!imgUrl || !imgUrl.trim()) return;

  // Price threshold is configured per page in admin, e.g.:
  var threshold = parseFloat(window.addBadge5MinPrice);
  if (!isFinite(threshold)) return;

  // Wait long enough for addImageBadge (waitForSlide) and addBadgePexesoDetail
  // (setTimeout 300ms) to finish, so we observe the final badge state.
  setTimeout(function () {
    var $firstSlide = $('.carousel__slide').first();
    if (!$firstSlide.length) return;

    // Lowest priority — skip if any other badge/gift/pexeso already rendered.
    if ($firstSlide.find('.product-badge-img').length) return;

    var priceAttr = $('[itemprop="price"]').first().attr('content');
    var price = parseFloat(priceAttr);
    if (!isFinite(price) || price <= threshold) return;

    var $badgeImg = $('<img>', {
      src: imgUrl,
      alt: 'flag-badge-5',
      class: 'product-badge-img flag-badge-5',
      loading: 'lazy',
    });
    $firstSlide.append($badgeImg);
  }, 800);
}

function repositionCustomCategories() {
  var btnShowMoreTerm, btnShowLessTerm;

  switch (lang) {
    case 'sk': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    case 'hu': btnShowMoreTerm = 'Továbbiak megjelenítése'; btnShowLessTerm = 'Kevesebb megjelenítése'; break;
    case 'cs': btnShowMoreTerm = 'Zobrazit více'; btnShowLessTerm = 'Zobrazit méně'; break;
    case 'ro': btnShowMoreTerm = 'Afișați mai multe'; btnShowLessTerm = 'Afișați mai puțin'; break;
    case 'bg': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    case 'hr': btnShowMoreTerm = 'Prikaži više'; btnShowLessTerm = 'Prikaži manje'; break;
    case 'sl': btnShowMoreTerm = 'Prikazati več'; btnShowLessTerm = 'Prikazati manj'; break;
    case 'uk': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    default: return;
  }

  const custom = document.querySelector('.custom-description-with-category');
  if (!custom) return;

  // presunieme len ul do do obsahu
  const pDetail = document.querySelector('.p-detail');
  if (pDetail && custom.parentNode !== pDetail) {
    pDetail.appendChild(custom);
  } else if (pDetail) {
    pDetail.appendChild(custom);
  }

  const itemsCount = custom.querySelectorAll('.custom-category-list > li').length;
  const shouldHaveToggle = itemsCount > 9;

  // wrapper na list, nie celý obsah
  let content = custom;

  const contentId = content.id || 'custom-desc';
  content.id = contentId;

  // keď netreba toggle
  if (!shouldHaveToggle) {
    custom.classList.remove('open');
    content.style.maxHeight = '';
    const oldBtn = custom.querySelector('.toggle-btn');
    if (oldBtn) oldBtn.remove();
    return;
  }

  // button
  let btn = custom.querySelector('.toggle-btn');
  if (!btn) {
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'toggle-btn';
    custom.appendChild(btn);

    btn.addEventListener('click', () => {
      const isOpen = custom.classList.toggle('open');
      btn.textContent = isOpen ? btnShowLessTerm : btnShowMoreTerm;
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '';
      }
    });
  }

  // init
  const isOpen = custom.classList.contains('open');
  btn.textContent = isOpen ? btnShowLessTerm : btnShowMoreTerm;
  btn.setAttribute('aria-controls', contentId);
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

  if (isOpen) {
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    content.style.maxHeight = '';
  }
}



